(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Grafika"] = factory();
	else
		root["Grafika"] = factory();
})(this, function() {
return webpackJsonpGrafika([2],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(118);


/***/ },

/***/ 118:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(4);
	
	var _canvas3d = __webpack_require__(119);
	
	var Canvas3d = _interopRequireWildcard(_canvas3d);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _window = window;
	var Cx = _window.Cx;
	
	
	(0, _lodash.assign)(Cx, Canvas3d);

/***/ },

/***/ 119:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _textureView = __webpack_require__(120);
	
	Object.keys(_textureView).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _textureView[key];
	    }
	  });
	});
	
	var _canvas3d = __webpack_require__(124);
	
	Object.keys(_canvas3d).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _canvas3d[key];
	    }
	  });
	});
	
	var _thumbnail = __webpack_require__(129);
	
	Object.keys(_thumbnail).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _thumbnail[key];
	    }
	  });
	});

/***/ },

/***/ 120:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextureView = exports.StaticTextureView = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _view = __webpack_require__(84);
	
	var _doc3dModelMixin = __webpack_require__(121);
	
	var _textureViewScene = __webpack_require__(123);
	
	var _move3d = __webpack_require__(122);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var fpsLimit = 6;
	
	var StaticTextureView = exports.StaticTextureView = _view.View.extend(_view.View2D_Mixin).extend(_view.DocumentView_Mixin).extend(_view.SelectedFigures_Mixin).extend(_cdl.FigureConditions_Mixin).extend(_doc3dModelMixin.Doc3D_Model_Mixin).extend({
	
	  typeName: 'StaticTextureView',
	
	  Properties: {
	
	    document: { type: 'Document', def: null, owned: false, set: function (v) {
	        this._setDoc(v);
	      }
	    },
	
	    canvas3D: { type: 'boolean', def: null, onChange: function (value) {
	        if (value && this.model) {
	          this.zoomToFitTextureFor(this.model);
	        }
	      }
	    },
	
	    // [TODO] onChange, fireEvent
	    backSideDarkFactor: { type: 'number', def: 0.5 },
	
	    backSideColor: { type: 'Color', def: null, get: function () {
	        return this._backSideColor || _cdl.Color.changeLuminosity(this.frontSideColor, -this.backSideDarkFactor);
	      }
	    },
	
	    textureSize: { type: 'number', def: null, onChange: function () {
	        this.updateSize();
	      }
	    }
	  },
	
	  get model() {
	    var doc = this.doc;
	
	    return doc && doc.model3D;
	  },
	
	  getThreeTexture: function (textureType) {
	    if (textureType === 'color') {
	      return this.scene.threeTexture;
	    } else {
	      // Textures compositions, full size, same as color
	      var texture = (0, _view.findByTextureType)(this.textures, textureType);
	      if (texture) {
	        return texture.threeTexture;
	      } else {
	        // Tiled textures
	        var tiledTexture = this.textureTiles[textureType];
	        if (tiledTexture) {
	          return tiledTexture.threeTexture;
	        }
	      }
	    }
	  },
	
	
	  get frontSideColor() {
	    return this.backgroundColor;
	  },
	  set frontSideColor(color) {
	    this.backgroundColor = color;
	  },
	
	  updateSize: function (w, h) {
	    var textureSize = this.textureSize;
	    var width = this.width;
	    var height = this.height;
	    var _previewing = this._previewing;
	
	    if (textureSize && arguments.length === 0) {
	      if (this.canvas3D) {
	        if (!_previewing && (textureSize !== width || textureSize !== height)) {
	          // console.log('full texture');
	          this.callParent(textureSize, textureSize);
	        } else if (_previewing) {
	          if (textureSize === 512) {
	            return;
	          }
	          var previewingTextureSize = Math.max(textureSize / (this.stats.fps > fpsLimit ? 2 : 4), 512);
	          if (!(previewingTextureSize === width && previewingTextureSize === height)) {
	            // console.log('preview texture ' + previewingTextureSize );
	            this.callParent(previewingTextureSize, previewingTextureSize);
	          }
	        }
	      } else {
	        this.callParent(textureSize, textureSize);
	      }
	    } else {
	      this.callParent(w, h);
	    }
	  },
	  postResize: function () {
	    if (this._modelReady) {
	      this.zoomToFitTextureFor(this.model);
	    }
	  },
	  createScene: function () {
	    return new _textureViewScene.TextureViewComposition({ main: true });
	  },
	  redrawFigure: function (figure) {
	    this.renderer.redraw(this, figure);
	  },
	  draw: function () {
	
	    if (!this._modelReady) {
	      return;
	    }
	    var canvas3D = this.canvas3D;
	
	    if (canvas3D) {
	      canvas3D.computeViewToTextureScale();
	    }
	    if (this._previewing && (0, _lodash.now)() - this._previewingT > 1200) {
	      this.endPreview();
	      this.render$();
	      return;
	    }
	    this.callParent();
	  },
	
	
	  // [TODO] This should be available at the view level
	  // This function will make sure that everything is ready to be rendered
	  // before drawing. Is used in the 3D thumbnail generation process.
	  draw$: function () {
	    var _this = this;
	
	    var doc = this.doc;
	    var zoom = this.zoom;
	
	    return doc.render$().then(function () {
	      return doc.prepareToDraw$(zoom).then(function () {
	        return (0, _gear.invokeMap$)(_this.mapToFigureViews(doc.figures), 'ready$').then(function () {
	          return (0, _gear.map$)(_this.textureTiles, 'promise').then(function () {
	            _this.redrawAll();
	            _this.draw();
	          });
	        });
	      });
	    });
	  },
	  zoomToFitTextureFor: function (model) {
	    var textureWidth = model.textureWidth;
	    var width = this.width;
	
	    this.zoom = width / textureWidth;
	    this.center = new _cdl.Point(textureWidth / 2, textureWidth / 2);
	    return this;
	  },
	  zoomToFitTexture$: function () {
	    var _this2 = this;
	
	    return this.loadModel3D$().then(function (model) {
	      // [TODO]
	      if (model) {
	        return _this2.zoomToFitTextureFor(model);
	      }
	    });
	  },
	  zoomToFit$: function () {
	    if (arguments.length === 0) {
	      return this.zoomToFitTexture$();
	    } else {
	      return this.zoomToFitFigures$.apply(this, arguments);
	    }
	  },
	  docToView: function () /* docPoint */{
	    console.log('TextureView docToView not supported');
	  },
	  docDeltaToView: function (docDelta) {
	    return this.viewTransform.docDeltaToView(this, docDelta);
	  },
	  viewToDoc: function (viewPoint, docIsland) {
	    return this.modelToDoc(viewPoint, docIsland);
	  },
	  docPoint: function (event, docIsland) {
	    return this.modelToDoc(this.modelPoint(event), docIsland);
	  },
	  textureDeltaToDoc: function (textureDelta) {
	    return this.viewTransform.viewDeltaToDoc(this, textureDelta);
	  },
	
	
	  // Overwritten in TextureView below
	  viewDeltaToDoc: function (viewDelta) {
	    return this.viewTransform.viewDeltaToDoc(this, viewDelta);
	  },
	  mapToFigureViews: function (figures) {
	    return this.figureViews.mapToFigureViews(figures);
	  },
	  figureView: function (figure) {
	    return this.figureViews.get(figure);
	  },
	  figureTextureTypes: function () {
	    return ['color']; // Allow 'normal', 'bump', 'specular'...
	  },
	  init: function () {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	
	    this.addEvents('synctextures');
	
	    this._previewing = false;
	    this._previewingT = 0;
	
	    this._modelReady = false;
	    this.figureViews = new _view.SyncedFigureViews({ view: this });
	
	    this.textureTiles = {};
	
	    this._backgroundColor = _cdl.Color.White();
	
	    this.callParent(config);
	
	    this._setDoc(new _cdl.Document());
	  },
	  insertViewPlugins: function (plugins) {
	    this.callParent(plugins);
	    var textureViewPlugins = [_view.Plugin.TextureMap({ textureType: 'color' }), _view.Plugin.TextureViewRenderer()];
	    if (!this.canvas3D) {
	      textureViewPlugins = (0, _gear.concat)(textureViewPlugins, [_view.Plugin.ViewControls(), _view.Plugin.PluginsLayer(), _view.Plugin.Tools()]);
	    }
	    plugins.insert(0, textureViewPlugins);
	  },
	  _setDoc: function (doc) {
	    var _this3 = this;
	
	    var old = this.doc;
	    if (old === doc) {
	      return (0, _gear.resolve)(); // Nothing to do
	    }
	    if (old) {
	      var model3D = old.model3D; // [TODO] This will be removed
	
	      if (model3D) {
	        model3D.un(this);
	      }
	
	      this.unlinkDoc(old);
	    }
	
	    this._modelReady = false;
	
	    this._document = doc;
	    this.linkDoc(doc);
	
	    if (!doc.is3D) {
	      return (0, _gear.resolve)();
	    }
	
	    return doc.loadModel3D$().then(function () {
	      // [TODO] We could avoid this by avoiding async processing for simple shapes
	      // This needs further research
	
	      /*
	      // We are only updating when the Doc3D fires events
	      doc.model3D.on({
	        'materialschanged': this.on_materialschanged,
	        'model3dchanged': this.on_model3dchanged,
	        'modeldata3dchanged': this.on_modeldata3dchanged,
	      },this);
	      */
	
	      return doc.model3D.update$().then(function () {
	
	        _this3.syncModel3D();
	
	        _this3._modelReady = true;
	        // console.log('modelReady');
	      });
	    });
	  },
	  linkDoc: function (doc) {
	    this.figureViews.link(doc);
	    this.callParent(doc);
	    this.fireEvent('newdocument', this, doc);
	  },
	  unlinkDoc: function (doc) {
	    this.figureViews.unlink(doc);
	  },
	  loadModel3D$: function () {
	    return this.doc.is3D ? this.doc.loadModel3D$() : (0, _gear.resolve)();
	  },
	  syncTextures: function () {
	    var _this4 = this;
	
	    // Sync full textures, color and optinal maps
	    // The idea is that each figure should be able to draw to these textures
	    // Tiled textures are directly loaded and cached by getThreeTexture
	
	    if (_config.Config.ignoreTextures) {
	      return;
	    }
	
	    var textures = this.textures;
	
	    // Sync texture backgrounds plugins
	
	    var plugins = this.plugins;
	
	    (0, _lodash.remove)(plugins, function (plugin) {
	      return plugin instanceof _view.Plugin.TextureMap && plugin.textureType !== 'color';
	    });
	
	    (0, _view.findByTextureType)(plugins, 'color').updateMap();
	
	    (0, _lodash.forEach)(['bump', 'normal', 'specular', 'displacement', 'alpha'], function (textureType) {
	
	      // This function ignores bump maps if there are normal maps
	      var textureMap = _this4.getFixedTextureMap(textureType);
	
	      var texture = (0, _view.findByTextureType)(textures, textureType);
	      if (textureMap && textureMap.wrap === 'Stretch') {
	        // [TODO] Enable it if figures want to draw things to this textureType
	        if (!texture) {
	          var composition = _this4.createTexture(textureType);
	          textures.push(composition);
	        }
	        plugins.unshift(_view.Plugin.TextureMap({ textureType: textureType }));
	      } else if (texture) {
	        if (texture.layersContainer) {
	          // [TODO]
	          texture.remove();
	        }
	        textures.remove(texture);
	      }
	
	      var textureTiles = _this4.textureTiles;
	
	      var tiledTexture = textureTiles[textureType];
	      if (textureMap && textureMap.wrap === 'Repeat') {
	        if (!tiledTexture || tiledTexture.id !== textureMap.id) {
	
	          textureTiles[textureType] = new _view.TextureTile(_this4, textureType, textureMap);
	        }
	      } else {
	        textureTiles[textureType] = null;
	      }
	    });
	
	    this.fireEvent('synctextures', this);
	  },
	  getFixedTextureMap: function (textureType) {
	    var model = this.model;
	    var doc = this.doc;
	
	    var docMaterial = doc && doc.materials && doc.materials[0];
	    if (textureType === 'normal' && docMaterial && docMaterial.getFixedTextureMap('bump')) {
	      // Ignore normal map in Model3D if there is a bump map in Doc3D
	      return null;
	    } else {
	      var modelMaterial = model && model.materials[0];
	      var docTextureMap = docMaterial && docMaterial.getFixedTextureMap(textureType);
	      var modelTextureMap = modelMaterial && modelMaterial.getFixedTextureMap(textureType);
	      return docTextureMap || modelTextureMap;
	    }
	  },
	  createTexture: function (textureType) {
	    return new _view.TextureComposition({ textureType: textureType });
	  },
	  syncModel3D: function () {
	    // console.log('syncModel3D');
	
	    this.syncTextures();
	
	    if (this.canvas3D) {
	      // Forces the texture to cover the requested textureSize ( 512, 1024, 2048 )
	      this.zoomToFitTextureFor(this.model);
	    }
	  },
	  on_materialschanged: function () {
	    this.syncModel3D();
	    this.callParent.apply(this, arguments);
	  },
	  on_model3dchanged: function () {
	    this.syncModel3D();
	    this.callParent.apply(this, arguments);
	  },
	
	  /*
	  on_modeldata3dchanged() {
	    },
	  */
	
	  optimizePreview: function () {
	    if (_config.Config.texturePreview) {
	      this._previewingResize = true;
	      this._previewing = true;
	      this._previewingT = (0, _lodash.now)();
	      this.updateSize();
	      this._previewingResize = false;
	    }
	  },
	  endPreview: function () {
	    if (this._previewing && this.width !== this.textureSize) {
	      this._previewingResize = true;
	      this._previewing = false;
	      this.updateSize();
	      this._previewingResize = false;
	    }
	  },
	
	
	  // [MODEL]
	  on_renderstarted: function (doc, type) {
	    if (this.canvas3D) {
	      if (type === 'preview') {
	        this.optimizePreview();
	      } else if (type === 'commit') {
	        this.endPreview();
	      }
	    }
	    this.callParent(doc, type);
	  },
	  dispose: function () {
	    if (this.doc) {
	      this.unlinkDoc(this.doc);
	    }
	    this.callParent();
	  },
	  onBackgroundColorChange: function () {
	    this.redraw('document');
	  },
	
	
	  get textureView() {
	    return this;
	  },
	
	  pluginDirectDomEventHandling: function (_ref) {
	    var target = _ref.target;
	
	    return target === 'view' || target === 'model';
	  },
	  createEventTracker: function (event, docIsland) {
	    return new _move3d.TextureTracker(event, docIsland);
	  }
	});
	
	var TextureView = exports.TextureView = StaticTextureView.extend(_view.InteractiveView_Mixin).extend({
	
	  typeName: 'TextureView',
	
	  // Rewire user interaction to Canvas3D if this texture is being used for it
	  // Plugins are right now added to the TextureView, because the rendering code
	  // looked complex to abstract. It may be a good idea to let the plugins in the
	  // 3D view and wire the rendering instead. This starts to look really complex.
	
	  get is3D() {
	    return !!this.canvas3D;
	  },
	
	  get selectAndDragEnabled() {
	    var canvas3D = this.canvas3D;
	
	    return canvas3D ? canvas3D.selectAndDragEnabled : false;
	  },
	
	  viewDeltaToDoc: function (delta) {
	    var canvas3D = this.canvas3D;
	
	    return canvas3D ? canvas3D.viewDeltaToDoc(delta) : this.callParent(delta);
	  },
	  viewDeltaToTexture: function (delta) {
	    var canvas3D = this.canvas3D;
	
	    return canvas3D ? canvas3D.viewDeltaToTexture(delta) : this.callParent(delta);
	  },
	  triggerKeyboard: function (event) {
	    var canvas3D = this.canvas3D;
	
	    return canvas3D ? canvas3D.triggerKeyboard(event) : this.callParent(event);
	  },
	  are: function () {
	    var canvas3D = this.canvas3D;
	
	    return canvas3D ? canvas3D.are.apply(canvas3D, arguments) : this.callParent.apply(this, arguments);
	  },
	  is: function () {
	    var canvas3D = this.canvas3D;
	
	    return canvas3D ? canvas3D.is.apply(canvas3D, arguments) : this.callParent.apply(this, arguments);
	  },
	
	
	  /*
	  condition() {
	    const { canvas3D } = this;
	    return canvas3D ? canvas3D.condition(...arguments) : this.callParent(...arguments);
	  },
	  */
	
	  status: function (s) {
	    var canvas3D = this.canvas3D;
	
	    return canvas3D ? canvas3D.status(s) : this.callParent(s);
	  },
	  get_cursor: function () {
	    var canvas3D = this.canvas3D;
	
	    return canvas3D ? canvas3D.cursor : this.callParent();
	  },
	  set_cursor: function (cursor) {
	    var canvas3D = this.canvas3D;
	
	    if (canvas3D) {
	      canvas3D.cursor = cursor;
	    } else {
	      this.callParent(cursor);
	    }
	  },
	  fireEvent: function (type) {
	    var canvas3D = this.canvas3D;
	
	    for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      params[_key - 1] = arguments[_key];
	    }
	
	    if (canvas3D) {
	      if (type === 'toolchanged' || type === 'figuresdrag' || type === 'figuresdrop') {
	
	        canvas3D.fireEvent.apply(canvas3D, [type].concat(_toConsumableArray(params)));
	      }
	    }
	    this.callParent.apply(this, [type].concat(_toConsumableArray(params)));
	  }
	});
	
	exports.default = TextureView;

/***/ },

/***/ 121:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Doc3D_Model_Mixin = undefined;
	
	var _cdl = __webpack_require__(15);
	
	var _move3d = __webpack_require__(122);
	
	function notTextureIsland(figure) {
	  return !(0, _cdl.isTextureIsland)(figure);
	}
	
	var Doc3D_Model_Mixin = exports.Doc3D_Model_Mixin = {
	
	  Properties: {
	    selectableIslands: { type: 'boolean', def: true }
	  },
	
	  init: function () {
	    this.callParent.apply(this, arguments);
	
	    // DocIslands can not be moved from these views
	    this.condition('movable', notTextureIsland);
	    this.condition('rotatable', notTextureIsland);
	    this.condition('removable', notTextureIsland);
	    this.condition('copyable', notTextureIsland);
	  },
	  activeSelectableFigures: function () {
	    // [TODO] activePageSelection, allowCrossPageSelection
	    return this.callParent();
	  },
	  uvToModel: function (uv) {
	    return this.model.uvToModel(uv);
	  },
	  uvToDoc: function (uv, docIsland) {
	    return this.modelToDoc(this.uvToModel(uv), docIsland);
	  },
	  modelToDoc: function (modelPoint, docIsland) {
	    if (docIsland === undefined) {
	      docIsland = this.topDocIslandAtModel(modelPoint);
	      if (!docIsland) {
	        return undefined;
	      }
	    }
	    var matrix = this.model.modelToDocMatrixFor(docIsland);
	    var docPoint = matrix.apply(modelPoint);
	    return docPoint;
	  },
	  topDocIslandAtModel: function (modelPoint, modelIsland) {
	    if (!modelIsland) {
	      modelIsland = this.modelIslandAt(modelPoint);
	    }
	    return modelIsland && this.topDocIslandFor(modelIsland);
	  },
	  topDocIslandFor: function (modelIsland) {
	    return this.doc.topDocIslandFor(modelIsland);
	  },
	  docIslandsFor: function (docIsland) {
	    return this.doc.docIslandsFor(docIsland);
	  },
	  modelIslandFor: function (docIsland) {
	    return this.model.modelIslandFor(docIsland);
	  },
	  modelIslandAt: function (modelPoint) {
	    return this.textureView._modelReady && this.model.modelIslandAt(modelPoint);
	  },
	  modelPointIsOut: function (modelPoint, modelIsland) {
	    return !modelIsland.bounds_().contains(modelPoint);
	  },
	  forEachDesignFiguresIn: function (name, func) {
	    var doc = this.doc;
	    var pages = doc.pages;
	
	    for (var p = 0, pEnd = pages.length; p < pEnd; ++p) {
	      var page = pages[p];
	      var designFigures = (0, _cdl.designFiguresFrom)(page);
	      var docIslands = (0, _cdl.docIslandsFrom)(page);
	      for (var i = 0, iEnd = docIslands.length; i < iEnd; ++i) {
	        var docIsland = docIslands[i];
	        if ((0, _cdl.textureIslandName)(docIsland) === name) {
	          func(docIsland, designFigures);
	        }
	      }
	    }
	  },
	  extractHitInfo: function (hit, info) {
	    if (hit) {
	      if (info) {
	        info.tight = hit.tight;
	        info.docPoint = hit.docPoint;
	        info.docIsland = hit.docIsland;
	      }
	      return hit.figure;
	    }
	    return hit;
	  },
	  figureAtModelPointEx: function (modelPoint, tabFigures) {
	    var candidates = this.candidateFiguresAtModelPoint(modelPoint);
	    return this.bestFigureCandidate(candidates, tabFigures);
	  },
	  filterSelectableInto: function (figures, r) {
	    // [TODO] filter by condition
	    for (var k = 0, kEnd = figures.length; k < kEnd; k++) {
	      var figure = figures[k];
	      if (this.is(figure, 'selectable')) {
	        r.push(figure);
	      }
	    }
	  },
	  rawFigureHitsAtModelPoint: function (modelPoint) {
	    return this.candidateFiguresAtModelPoint(modelPoint, true);
	  },
	  candidateFiguresAtModelPoint: function (modelPoint) {
	    var raw = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var selectableIslands = this.selectableIslands;
	
	    var candidates = [];
	    var modelIsland = this.modelIslandAt(modelPoint);
	    var docIslandCandidates = [];
	    var pages = this.doc.pages;
	
	    for (var p = pages.length - 1; p >= 0; --p) {
	      var page = pages[p];
	
	      if (raw || !page._locked && !page._hidden) {
	
	        var pagedDesignLayers = (0, _cdl.designLayersFrom)(page);
	        var designLayers = raw ? pagedDesignLayers : (0, _cdl.filterTargetLayers)(pagedDesignLayers);
	
	        var figures = void 0;
	        if (raw) {
	          figures = _cdl.Layers.flatten(designLayers);
	        } else {
	          figures = [];
	          for (var l = 0, lEnd = designLayers.length; l < lEnd; ++l) {
	            this.filterSelectableInto(designLayers[l].figures, figures);
	          }
	        }
	
	        var docIslands = (0, _cdl.filterIslandsFor)((0, _cdl.docIslandsFrom)(page), modelIsland);
	
	        for (var f = figures.length - 1; f >= 0; --f) {
	          var figure = figures[f];
	
	          for (var i = docIslands.length - 1; i >= 0; --i) {
	            var docIsland = docIslands[i];
	            var docPoint = (0, _cdl.modelToDocMatrix)(docIsland, modelIsland).apply(modelPoint);
	
	            if (figure.globalFrame_().contains(docPoint)) {
	              candidates.push({
	                figure: figure, docIsland: docIsland, docPoint: docPoint,
	                tight: raw ? figure.containsPoint(docPoint) : false
	              });
	            }
	          }
	        }
	
	        if (raw || selectableIslands) {
	          for (var _i = docIslands.length - 1; _i >= 0; --_i) {
	            var _docIsland = docIslands[_i];
	            var _docPoint = (0, _cdl.modelToDocMatrix)(_docIsland, modelIsland).apply(modelPoint);
	            docIslandCandidates.push({
	              figure: _docIsland, docIsland: _docIsland, docPoint: _docPoint,
	              tight: raw ? _docIsland.containsPoint(_docPoint) : false
	            });
	          }
	        }
	      }
	    }
	
	    return candidates.concat(docIslandCandidates);
	  },
	  on_domEvent: function (_ref) {
	    var event = _ref.event;
	    var type = _ref.type;
	    var isPrimary = _ref.isPrimary;
	
	
	    if (isPrimary && type === 'pointerdown') {
	      var modelPoint = event.modelPoint;
	
	      if (modelPoint && this.modelIslandAt(modelPoint)) {
	        // track3D.log(`[3D] Start tracking of ${type}`);
	        var docIsland = this.topDocIslandAtModel(modelPoint);
	        if (docIsland) {
	          this.tracker = this.createEventTracker(event, docIsland);
	        }
	      }
	    }
	
	    this.callParent(event);
	
	    if (isPrimary && this.tracker && type === 'pointerup') {
	      // track3D.log(`[3D] End tracking of ${type}`);
	      this.tracker = null;
	    }
	  },
	  handlePluginDomEvent: function (plugin, _ref2) {
	    var event = _ref2.event;
	    var type = _ref2.type;
	    var route = _ref2.route;
	    var isPrimary = _ref2.isPrimary;
	
	
	    if (this.pluginDirectDomEventHandling(plugin)) {
	      plugin.handleDomEvent(event);
	      return;
	    }
	
	    // We avoid providing feedback in case of 3D views, as it is slowing down
	    // things for complex models. It is also not clear how to handle properly
	    // feedback in tools if there are several islands. 
	    if (false) {
	      var modelPoint = event.modelPoint;
	
	      var modelIsland = modelPoint && this.modelIslandAt(modelPoint);
	      if (modelIsland) {
	        var docIslands = this.docIslandsFor(modelIsland);
	        for (var i = docIslands.length - 1; i >= 0 && !event.stopped; --i) {
	          var docIsland = docIslands[i];
	          var newEvent = (0, _move3d.retargetEvent3D)(event, docIsland);
	          plugin.on_domEvent(newEvent);
	          if (newEvent.stopped) {
	            event.stopPropagation();
	          }
	        }
	      }
	    }
	
	    if (type === 'pointerdown' && isPrimary) {
	      var _modelPoint = event.modelPoint;
	
	      var _modelIsland = _modelPoint && this.modelIslandAt(_modelPoint);
	      if (_modelIsland) {
	
	        if (plugin.has_try_pointerdown()) {
	
	          var _docIslands = this.docIslandsFor(_modelIsland);
	
	          for (var _i2 = _docIslands.length - 1; _i2 >= 0 && !event.stopped; --_i2) {
	            var _docIsland2 = _docIslands[_i2];
	
	            var tracker = this.createEventTracker(event, _docIsland2);
	            var _newEvent = tracker.retargetedEvent;
	            // track3D.log(`[3D] Try to start Tracking of ${type}`);
	            plugin.try_pointerdown(_newEvent);
	            if (_newEvent.stopped) {
	              this.tracker = tracker; // Change the default tracking to follow this island
	              event.stopPropagation();
	            }
	          }
	
	          if (event.stopped) {
	            return false;
	          }
	        }
	
	        // track3D.log(`[3D] ${type}`);
	        plugin.on_domEvent(event);
	      }
	    } else if ((type === 'pointermove' || type === 'pointerup') && isPrimary) {
	
	      if (this.tracker) {
	        // even if modelPoint is null, we track these events
	        var _newEvent2 = this.tracker.move(event);
	        plugin.on_domEvent(_newEvent2);
	        if (_newEvent2.stopped) {
	          event.stopPropagation();
	        }
	      }
	    } else if (type === 'click' || type === 'dblcick' || type === 'contextmenu') {
	      var _modelPoint2 = event.modelPoint;
	
	      var _modelIsland2 = _modelPoint2 && this.modelIslandAt(_modelPoint2);
	      if (_modelIsland2) {
	
	        var tryHandler = 'try_' + type;
	        if (plugin['has_' + tryHandler]()) {
	
	          var _docIslands2 = this.docIslandsFor(_modelIsland2);
	          for (var _i3 = _docIslands2.length - 1; _i3 >= 0 && !event.stopped; --_i3) {
	            var _docIsland3 = _docIslands2[_i3];
	            // track3D.log(`[3D] Retarget of ${type}, using try_`);
	            var _newEvent3 = (0, _move3d.retargetEvent3D)(event, _docIsland3);
	            plugin[tryHandler](_newEvent3);
	            if (_newEvent3.stopped) {
	              event.stopPropagation();
	            }
	          }
	
	          if (event.stopped) {
	            return false;
	          }
	        }
	        // track3D.log(`[3D] Direct routing of ${type}`);
	        plugin.on_domEvent(event);
	      }
	    } else if (type === 'keypress' || type === 'keydown' || type === 'keyup' || type === 'mousewheel' || type === 'focus' || type === 'focusout') {
	
	      // track3D.log(`[3D] Direct routing of ${type}`);
	      plugin.on_domEvent(event);
	    }
	  }
	};

/***/ },

/***/ 122:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextureTracker = exports.Tracker3D = undefined;
	exports.retargetEvent3D = retargetEvent3D;
	
	var _lodash = __webpack_require__(4);
	
	var _cdl = __webpack_require__(15);
	
	// Simple retargetting without tracking
	
	var SimpleTracker3D = function (event, docIsland) {
	  this._event = event;
	  this._docIsland = docIsland;
	};
	SimpleTracker3D.prototype.track = function (_ref) {
	  var view = _ref.view;
	
	
	  var docIsland = this._docIsland,
	      modelPoint = this._event.modelPoint,
	      // Important, this._event is different from track(event) here
	  modelIsland = view.modelIslandFor(docIsland),
	      docPoint = view.modelToDoc(modelPoint, docIsland);
	
	  return {
	    modelPoint: modelPoint,
	    modelIsland: modelIsland,
	    docIsland: docIsland,
	    docPoint: docPoint,
	    modelPointRaw: modelPoint,
	    modelIslandRaw: modelIsland,
	    docIslandRaw: docIsland,
	    docPointRaw: docPoint
	  };
	};
	
	function retargetEvent3D(event, docIsland) {
	  return event.retarget(event.eventDown, new SimpleTracker3D(event, docIsland));
	}
	
	// Move3D helper to track the mouse starting from a given doc island
	// and following it even if it goes out it or the model
	
	var Tracker3D = exports.Tracker3D = function (_ref2, docIsland) {
	  var view = _ref2.view;
	  var event = _ref2.event;
	  var viewPoint = _ref2.viewPoint;
	  var modelPoint = _ref2.modelPoint;
	
	
	  var docPoint = view.modelToDoc(modelPoint, docIsland);
	  var modelIsland = view.modelIslandFor(docIsland);
	
	  (0, _lodash.assign)(this, { view: view,
	
	    event: event,
	    eventDown: event,
	
	    // Points following the original island
	    // This is used for almost all tools
	    modelPoint: modelPoint,
	    modelIsland: modelIsland,
	    docIsland: docIsland,
	    docPoint: docPoint,
	
	    // Tracking, always against the docIslandDown
	    viewPointLast: viewPoint,
	    modelPointLast: modelPoint,
	
	    // Points that jumps between islands, useful for move operations
	    modelPointRaw: modelPoint,
	    modelIslandRaw: modelIsland,
	    docIslandRaw: docIsland,
	    docPointRaw: docPoint,
	
	    // Raw tracking, front => sleeve => out (should use sleeve points)
	    viewPointFirstRaw: viewPoint,
	    viewPointLastRaw: viewPoint,
	
	    modelPointFirstRaw: modelPoint,
	    modelPointLastRaw: modelPoint,
	
	    started: false
	  });
	
	  this.retargetedEventDown = this.retargetedEvent;
	};
	
	Tracker3D.prototype = {
	
	  get retargetedEvent() {
	    return this.event.retarget(this.retargetedEventDown, this);
	  },
	
	  track: function () {
	    var _event = this.event;
	    var view = _event.view;
	    var viewPoint = _event.viewPoint;
	    var originalEvent = _event.originalEvent;
	
	    var modelPoint = view.modelPoint(originalEvent);
	
	    var eventDown = this.eventDown;
	    var docIsland = this.docIsland;
	    var modelIsland = this.modelIsland;
	
	
	    if (modelPoint && !modelPoint.isEqual(eventDown.modelPoint)) {
	      this.started = true;
	    }
	
	    if (!this.started) {
	      return this.trackData();
	    }
	
	    var modelPointRaw = modelPoint;
	
	    if (modelPoint && !view.modelPointIsOut(modelPoint, modelIsland)) {
	
	      this.modelPoint = modelPoint;
	
	      this.viewPointLast = viewPoint;
	      this.modelPointLast = modelPoint;
	    } else {
	
	      // We need to come up with a proper modelPoint to continue the movement
	      this.modelPoint = interpolatingExtension(viewPoint, eventDown.viewPoint, this.viewPointLast, eventDown.modelPoint, this.modelPointLast);
	    }
	
	    this.docPoint = view.modelToDoc(this.modelPoint, this.docIsland);
	
	    // Raw properties
	
	    if (modelPointRaw && view.modelPointIsOut(modelPointRaw, this.modelIslandRaw)) {
	
	      var docIslandRaw = view.topDocIslandAtModel(modelPointRaw);
	      if (docIslandRaw && docIslandRaw.page === docIsland.page) {
	        this.modelIslandRaw = view.modelIslandAt(modelPointRaw);
	        this.docIslandRaw = docIslandRaw;
	
	        this.viewPointFirstRaw = viewPoint;
	        this.modelPointFirstRaw = modelPointRaw;
	      } else {
	        // Trigger interpolation
	        modelPointRaw = null;
	      }
	    }
	
	    if (modelPointRaw) {
	
	      this.modelPointRaw = modelPointRaw;
	
	      this.viewPointLastRaw = viewPoint;
	      this.modelPointLastRaw = modelPointRaw;
	    } else {
	
	      // We need to come up with a proper modelPointRaw to continue the movement
	      this.modelPointRaw = interpolatingExtension(viewPoint, this.viewPointFirstRaw, this.viewPointLastRaw, this.modelPointFirstRaw, this.modelPointLastRaw);
	    }
	
	    this.docPointRaw = view.modelToDoc(this.modelPointRaw, this.docIslandRaw);
	
	    return this.trackData();
	  },
	  trackData: function () {
	    return {
	      modelIsland: this.modelIsland,
	      docIsland: this.docIsland,
	      docPoint: this.docPoint,
	      modelPointRaw: this.modelPointRaw,
	      modelIslandRaw: this.modelIslandRaw,
	      docIslandRaw: this.docIslandRaw,
	      docPointRaw: this.docPointRaw
	    };
	  },
	  move: function (event) {
	    this.event = event;
	    return this.retargetedEvent;
	  }
	};
	
	// Move3D helper to track the mouse starting from a given doc island
	// and following it even if it goes out it or the model
	
	var TextureTracker = exports.TextureTracker = function (_ref3, docIsland) {
	  var view = _ref3.view;
	  var event = _ref3.event;
	  var viewPoint = _ref3.viewPoint;
	  var modelPoint = _ref3.modelPoint;
	
	
	  var docPoint = view.modelToDoc(modelPoint, docIsland);
	  var modelIsland = view.modelIslandFor(docIsland);
	
	  (0, _lodash.assign)(this, { view: view,
	
	    event: event,
	    eventDown: event,
	
	    // Points following the original island
	    // This is used for almost all tools
	    modelPoint: modelPoint,
	    modelIsland: modelIsland,
	    docIsland: docIsland,
	    docPoint: docPoint,
	
	    // Points that jumps between islands, useful for move operations
	    modelPointRaw: modelPoint,
	    modelIslandRaw: modelIsland,
	    docIslandRaw: docIsland,
	    docPointRaw: docPoint,
	
	    started: false
	  });
	
	  this.retargetedEventDown = this.retargetedEvent;
	};
	
	TextureTracker.prototype = {
	
	  get retargetedEvent() {
	    return this.event.retarget(this.retargetedEventDown, this);
	  },
	
	  track: function () {
	    var _event2 = this.event;
	    var view = _event2.view;
	    var originalEvent = _event2.originalEvent;
	
	
	    var modelPoint = view.modelPoint(originalEvent);
	
	    var eventDown = this.eventDown;
	    var docIsland = this.docIsland;
	
	
	    if (modelPoint && !modelPoint.isEqual(eventDown.modelPoint)) {
	      this.started = true;
	    }
	
	    if (!this.started) {
	      return this.trackData();
	    }
	
	    this.modelPoint = modelPoint;
	    this.docPoint = view.modelToDoc(modelPoint, docIsland);
	
	    // Raw properties
	
	
	    if (view.modelPointIsOut(modelPoint, this.modelIslandRaw)) {
	
	      var docIslandRaw = view.topDocIslandAtModel(modelPoint);
	      if (docIslandRaw && docIslandRaw.page === docIsland.page) {
	        this.modelIslandRaw = view.modelIslandAt(modelPoint);
	        this.docIslandRaw = docIslandRaw;
	      }
	    }
	
	    this.modelPointRaw = modelPoint;
	    this.docPointRaw = view.modelToDoc(modelPoint, this.docIslandRaw);
	
	    return this.trackData();
	  },
	  trackData: function () {
	    return {
	      modelIsland: this.modelIsland,
	      docIsland: this.docIsland,
	      docPoint: this.docPoint,
	      modelPointRaw: this.modelPointRaw,
	      modelIslandRaw: this.modelIslandRaw,
	      docIslandRaw: this.docIslandRaw,
	      docPointRaw: this.docPointRaw
	    };
	  },
	  move: function (event) {
	    this.event = event;
	    return this.retargetedEvent;
	  }
	};
	
	function interpolatingExtension(newFrom, firstFrom, lastFrom, firstTo, lastTo) {
	
	  if (firstFrom.isEqual(lastFrom)) {
	    return lastTo.clone();
	  }
	
	  var last_firstFrom = lastFrom.minus(firstFrom),
	      last_firstFrom_norm = last_firstFrom.norm(),
	      last_firstFrom_n = last_firstFrom.scaled(1 / last_firstFrom_norm),
	      new_firstFrom = newFrom.minus(firstFrom),
	      dotProductFrom = _cdl.Point.dotProduct(last_firstFrom, new_firstFrom),
	      ap = last_firstFrom_n.scaled(dotProductFrom / last_firstFrom_norm),
	      alpha = ap.norm() / last_firstFrom_norm * (dotProductFrom >= 0 ? 1 : -1),
	      bp = new_firstFrom.minus(ap),
	      beta = bp.norm() / last_firstFrom_norm * (_cdl.Point.dotProduct(bp, last_firstFrom.perpendicular(-1)) >= 0 ? -1 : 1),
	      last_firstTo = lastTo.minus(firstTo),
	      adp = last_firstTo.scaled(alpha),
	      bdp = last_firstTo.perpendicular(-1).scaled(beta);
	
	  return firstTo.plus(adp).plus(bdp);
	}

/***/ },

/***/ 123:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextureViewComposition = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _view = __webpack_require__(84);
	
	var filterProcessed = _cdl.Figures.filterProcessed;
	
	
	function processedDocIslandsFor(page, modelIsland) {
	  // filterProcessed( filter( docIslandsFrom(page), isDocIslandFor(modelIsland) ) );
	  var modelIslandName = (0, _cdl.textureIslandName)(modelIsland);
	  var pageDocIslands = (0, _cdl.docIslandsFrom)(page);
	  var docIslands = [];
	  for (var pdi = 0, pdiEnd = pageDocIslands.length; pdi < pdiEnd; ++pdi) {
	    var island = pageDocIslands[pdi];
	    if (island.processed() && (0, _cdl.textureIslandName)(island) === modelIslandName) {
	      docIslands.push(island);
	    }
	  }
	  return docIslands;
	}
	
	var TextureViewComposition = exports.TextureViewComposition = _view.TextureComposition.extend({ typeName: 'TextureViewComposition',
	
	  clearComposedCanvas: function () {
	    if (!this.canvas3D) {
	      // No need to clear the canvas in case the texture is used for a canvas3D
	      this.callParent();
	    }
	  },
	
	
	  // Overwrite drawPlugin to add the logic of rendering each plugin
	  // once for every texture island
	  drawPlugin: function (view, plugin, name, context) {
	
	    if (!view._modelReady) {
	      return; // There isn't a Doc3D properly loaded yet
	    }
	
	    if (!plugin.somethingToDraw()) {
	      return; // Optimization
	    }
	
	    var model = view.model;
	    var target = plugin.target;
	
	
	    if (target === 'view' || target === 'model') {
	
	      this.callParent(view, plugin, name, context);
	    } else {
	
	      var transformModel = view.getViewPortTransform();
	
	      var drawConfig = view.drawConfig();
	
	      var modelIslands = model.modelIslands;
	
	      for (var i = 0, iEnd = modelIslands.length; i < iEnd; ++i) {
	        var modelIsland = modelIslands[i];
	
	        var config = (0, _lodash.assign)({ view: view, context: context, transformModel: transformModel, modelIsland: modelIsland }, drawConfig);
	
	        context.save();
	
	        if (!_config.Config.clipTest1) {
	          var bleedModelIsland = model.bleedModelIslandWithName((0, _cdl.textureIslandName)(modelIsland));
	          bleedModelIsland.polyregions[0].clipContext(context, transformModel);
	        }
	
	        if (target === 'textureIslands') {
	
	          // The draw function is called once for every texture island clipped to it
	          this.drawPlugin2D(view, plugin, name, (0, _lodash.assign)({
	            transform: transformModel
	          }, config));
	        } else {
	          // target === 'document'
	
	          var pages = view.pages;
	
	          for (var p = 0, pEnd = pages.length; p < pEnd; ++p) {
	            var page = pages[p];
	
	            var docIslands = processedDocIslandsFor(page, modelIsland);
	
	            for (var d = 0, dEnd = docIslands.length; d < dEnd; ++d) {
	              var docIsland = docIslands[d];
	
	              // Optimization, no need to draw the plugin if it doesn't overlap with this docIsland
	              if (plugin.needsToDrawFor(docIsland)) {
	
	                var transformDoc = _cdl.Matrix.m(transformModel, (0, _cdl.docToModelMatrix)(docIsland, modelIsland));
	
	                // The draw function is called, once for every pair texture island <-> docisland
	                this.drawPlugin2D(view, plugin, name, (0, _lodash.assign)({
	                  docIsland: docIsland,
	                  transformDoc: transformDoc,
	                  transform: transformDoc
	                }, config));
	              }
	            }
	          }
	        }
	
	        context.restore(); // Remove clipping
	      }
	    }
	  }
	});
	
	_view.Plugin.TextureViewRenderer = _view.Plugin.extend({ typeName: 'TextureViewRendererPlugin',
	
	  name: 'renderer',
	
	  drawTo_color: ['document'],
	
	  // The draw function will be called, once for every texture island and all
	  // drawing will be clipped to it.
	  // We need to do it like this to respect the z-order of figures
	  target: 'textureIslands',
	
	  redrawFigure: function () /*view,figure*/{
	    this.redraw();
	  },
	  draw: function (config) {
	    var view = config.view;
	    var context = config.context;
	    var transformModel = config.transformModel;
	    var modelIsland = config.modelIsland;
	    var doc = view.doc;
	
	    // First draw the islands background, using the top most island across all pages
	    // Transparent brushes will show the color texture underneath
	
	    {
	      var backgroundDocIsland = doc.topDocIslandFor(modelIsland);
	      if (backgroundDocIsland && backgroundDocIsland.processed()) {
	        var transformDoc = _cdl.Matrix.m(transformModel, (0, _cdl.docToModelMatrix)(backgroundDocIsland, modelIsland));
	        var brush = backgroundDocIsland.polyregions[0].brush;
	
	        if (!(brush._empty || brush.typeName === 'Brush' && brush.color.alpha === 0)) {
	          view.figureView(backgroundDocIsland).draw(context, transformDoc, (0, _lodash.defaults)({ transformDoc: transformDoc, ignorePen: true }, config));
	        }
	      }
	    }
	
	    // Then draw all the figures, respecting their z-order in their layers and
	    // between pages. The last page will have the top most figures
	
	    var pages = doc.pages;
	
	    for (var p = 0, pEnd = pages.length; p < pEnd; ++p) {
	      var page = doc.pages[p];
	
	      var docIslands = processedDocIslandsFor(page, modelIsland);
	
	      var designLayers = (0, _cdl.designLayersFrom)(page);
	      for (var l = 0, lEnd = designLayers.length; l < lEnd; ++l) {
	        var layer = designLayers[l];
	
	        layer.beforeDraw(context, config);
	
	        var figures = filterProcessed(layer.figures);
	
	        for (var i = 0, iEnd = figures.length; i < iEnd; ++i) {
	          var figure = figures[i];
	
	          for (var di = 0, diEnd = docIslands.length; di < diEnd; ++di) {
	            var docIsland = docIslands[di];
	
	            // Optimization, no need to draw the figure if it doesn't overlap with this docIsland
	            if (_cdl.Frame.areOverlapping(docIsland.frame_(), figure.frame_())) {
	
	              // Change the transformDoc of the config
	              var _transformDoc = _cdl.Matrix.m(transformModel, (0, _cdl.docToModelMatrix)(docIsland, modelIsland));
	              var figureView = view.figureView(figure);
	
	              if (figureView) {
	                figureView.draw(context, _transformDoc, (0, _lodash.defaults)({ transformDoc: _transformDoc }, config));
	              } else {
	                console.log('[Error] FigureView is undefined');
	              }
	
	              if (view.showPin) {
	                // Do it as a config option
	                (0, _gear.dot)(context, figure.pin, view.viewDeltaToTexture(3), _transformDoc, '#ffffff', '#222222', view.viewDeltaToTexture(4));
	              }
	            }
	          }
	        }
	
	        layer.afterDraw(context, config);
	      }
	    }
	  }
	});

/***/ },

/***/ 124:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Canvas3D = exports.StaticCanvas3D = undefined;
	
	var _config = __webpack_require__(2);
	
	var _gear = __webpack_require__(8);
	
	var _lodash = __webpack_require__(4);
	
	var _cdl = __webpack_require__(15);
	
	var _view3d = __webpack_require__(125);
	
	var _view = __webpack_require__(84);
	
	var _doc3dModelMixin = __webpack_require__(121);
	
	var _textureView2 = __webpack_require__(120);
	
	var _threeUtil = __webpack_require__(127);
	
	var _object3d = __webpack_require__(128);
	
	var _move3d = __webpack_require__(122);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var StaticCanvas3D = exports.StaticCanvas3D = _view3d.View3D.extend(_view.DocumentView_Mixin).extend(_view.SelectedFigures_Mixin).extend(_cdl.FigureConditions_Mixin).extend(_doc3dModelMixin.Doc3D_Model_Mixin).extend({
	
	  typeName: 'StaticCanvas3D',
	
	  Properties: {
	
	    document: { type: 'Document', def: null, owned: false, set: function (v) {
	        this._setDoc(v);
	      }
	    },
	
	    textureView: { type: 'TextureView', def: null, owned: false, set: function (v) {
	        this._setTextureView(v);
	      }
	    },
	
	    // [TODO]
	    documentFilter: { type: 'function', def: null } // Used by load$ by id
	  },
	
	  // [TODO]
	  // backSideDarkFactor
	  // backSideColor
	
	  get model() {
	    return this.doc.model3D;
	  },
	
	  get modelData() {
	    return this.doc.modelData3D;
	  },
	
	  get textureSize() {
	    return this.textureView.textureSize;
	  },
	  set textureSize(textureSize_) {
	    this.textureView.textureSize = textureSize_;
	  },
	
	  isIddle: function () {
	    return this.callParent() && this.modelData && !this._transformMode;
	  },
	  insertViewPlugins: function (plugins) {
	
	    plugins.insert(0, [_view.Plugin.PluginsLayer(), _view.Plugin.FigureAnnotations(), // [TODO] Let users add this on demand
	
	    _view.Plugin.Tools()]);
	
	    this.callParent(plugins);
	  },
	  annotate: function () /* ...params */{
	    var _figureAnnotations;
	
	    return (_figureAnnotations = this.figureAnnotations).annotate.apply(_figureAnnotations, arguments);
	  },
	  unannotate: function () /* ...params */{
	    var _figureAnnotations2;
	
	    return (_figureAnnotations2 = this.figureAnnotations).unannotate.apply(_figureAnnotations2, arguments);
	  },
	  clearAnnotations: function () /* ...params */{
	    var _figureAnnotations3;
	
	    return (_figureAnnotations3 = this.figureAnnotations).clearAnnotations.apply(_figureAnnotations3, arguments);
	  },
	  add: function (figures, config) {
	    var selector = config && config.layer || this.destinationLayerSelector;
	    if (selector) {
	      this.setActiveLayerBy(selector);
	    }
	    return this.callParent(figures, config);
	  },
	  setActiveLayerBy: function (selector) {
	    var doc = this.doc;
	
	    var layer = doc.activePage.layerBy(selector);
	    if (layer) {
	      this.activeLayer = layer;
	    }
	    return this;
	  },
	  figureView: function (figure) {
	    return this.textureView.figureView(figure);
	  },
	
	
	  get figureViews() {
	    return this.textureView.figureViews;
	  },
	
	  figureTextureTypes: function () {
	    return this.textureView.figureTextureTypes();
	  },
	  asFastOffset: function (offset) {
	    return this.textureView.asFastOffset(offset);
	  },
	  docPoint: function (event, docIsland) {
	    var modelPoint = this.modelPoint(event);
	    return modelPoint && this.modelToDoc(modelPoint, docIsland);
	  },
	  modelPoint: function (event) {
	    var uv = this.uvPoint(event);
	    return uv && this.uvToModel(uv);
	  },
	  uvPoint: function (event) {
	    return this.viewToUV(this.viewPoint(event));
	  },
	  viewToUV: function (viewPoint) {
	    var camera = this.camera;
	    var width = this.width;
	    var height = this.height;
	
	    var uv = this.object3D.uvFromViewPoint(camera, viewPoint, width, height);
	    this.computeViewToTextureScale(); // [TODO] We should move this to a better place
	    return uv;
	  },
	  viewDeltaToDoc: function (delta) {
	    return this.textureView.textureDeltaToDoc(this.viewDeltaToTexture(delta));
	  },
	  computeViewToTextureScale: function (viewPoint) {
	    var _this = this;
	
	    if (!this._viewToTextureScale) {
	      (function () {
	        var camera = _this.camera;
	        var width = _this.width;
	        var height = _this.height;
	
	        if (!viewPoint) {
	          viewPoint = new _cdl.Point(width / 2, height / 2); // Stable... always the same on each model load
	        }
	        var uv = _this.object3D.uvFromViewPoint(camera, viewPoint, width, height);
	        if (uv) {
	          (function () {
	            var dist = 5;
	            var testPoints = [viewPoint.translated_(0, dist), viewPoint.translated_(0, -dist), viewPoint.translated_(dist, 0), viewPoint.translated_(-dist, 0)];
	            var scales = [];
	            (0, _lodash.forEach)(testPoints, function (point) {
	              var uv_close = _this.object3D.uvFromViewPoint(camera, point, width, height);
	              if (uv_close) {
	                scales.push(uv_close.minus(uv).norm() / dist);
	              }
	            });
	            var uv_scale = Math.min.apply(Math, scales); // [TODO] Use median ?
	            var scale = uv_scale * _this.textureSize; // * 1.25;
	
	            var controls = _this.controls;
	
	            var c = camera.position.clone().sub(controls.target).length();
	            _this._viewToTextureScale = {
	              scale: scale,
	              dist: c,
	              width: width, height: height
	            };
	          })();
	        }
	
	        _this.redraw('tools', 'plugins');
	      })();
	    }
	  },
	  postResize: function () {
	    this.callParent();
	    if (!this.textureView._previewingResize) {
	      this._viewToTextureScale = null;
	      this.computeViewToTextureScale();
	    }
	    if (_config.Config.keepLowerLeftCornerAsOrigin) {
	      this.center = this.viewCenter;
	    }
	  },
	  resetToOrigin: function () {
	    this.zoom = 1;
	    this.center = this.viewCenter;
	  },
	  viewDeltaToTexture: function (viewDelta) {
	    var camera = this.camera;
	    var controls = this.controls;
	    var textureView = this.textureView;
	
	    var c = camera.position.clone().sub(controls.target).length();
	
	    var s = this._viewToTextureScale;
	    if (s) {
	
	      var rs = viewDelta * s.scale * (this.textureView.width / this.textureSize) * Math.sqrt((c + 0.1) / s.dist); // Account for zooming
	
	      // if( viewDelta === 1 ) { console.log(rs+' / '+c+' / '+s.dist+' / '+this.textureView.width+' / '+s.scale); }
	      return rs;
	    }
	
	    var rse = viewDelta * 3 * (textureView.width / this.textureSize) * Math.sqrt((c + 0.1) / 200); //this.controls.zoom;
	
	    // if( viewDelta === 1 ) { console.log('E: '+ rse+' / '+c+' / '+this.textureView.width); }
	    return rse;
	  },
	
	
	  // Useful for default place where to add figures
	  get frontDocIsland() {
	    // [TODO] Use raytracing
	    return this.doc.topDocIsland; // this.doc.topDocIslandFor( this.model.modelIslands[0] );
	  },
	
	  // [TODO] The coupling between Canvas3D and its TextureView is now quite complex
	  // This is mainly to let plugins talk with the textureView or the canvas3D as if
	  // their will be the same thing. It may be better at the end to leave the plugins
	  // initialized with the Canvas3D, and forward the drawing instead of the way it
	  // is done now.
	  redraw: function () {
	    var _textureView;
	
	    (_textureView = this.textureView).redraw.apply(_textureView, arguments);
	    this.callParent.apply(this, arguments);
	  },
	
	
	  get textureZoom() {
	    return this.textureView.zoom;
	  },
	
	  // Load by id or set document, the promise finished when the 3D model is shown
	  load$: function (doc) {
	    var _this2 = this;
	
	    this.fireEvent('loading', this);
	
	    if (typeof doc === 'string') {
	
	      return _cdl.Document.load$(doc).then(function (loadedDoc) {
	        return (0, _gear.resolve)(_this2._documentFilter ? _this2._documentFilter(loadedDoc) : true).then(function () {
	
	          return _this2._setDoc(loadedDoc);
	        });
	      });
	    }
	
	    return this._setDoc(doc);
	  },
	  onLoaded: function () {
	    this._readyDeferred.resolve(this.doc);
	    this._readyDeferred = null;
	    this.fireEvent('loaded', this);
	  },
	
	
	  get controlsEnabled() {
	    return this.controls.enabled;
	  },
	  set controlsEnabled(state) {
	    var controls = this.controls;
	
	    if (state === false && this._controlsPanning) {
	      controls.onMouseUp();
	      this._controlsPanning = false;
	    }
	    controls.enabled = state;
	  },
	  setOrbitMode: function () {
	    this.controls.mouseButtons = { ORBIT: THREE.MOUSE.LEFT, ZOOM: THREE.MOUSE.MIDDLE, PAN: THREE.MOUSE.RIGHT };
	  },
	  setPanMode: function () {
	    this.controls.mouseButtons = { ORBIT: THREE.MOUSE.RIGHT, ZOOM: THREE.MOUSE.MIDDLE, PAN: THREE.MOUSE.LEFT };
	  },
	
	  get isOrbitMode() {
	    return this.controls.mouseButtons.ORBIT == THREE.MOUSE.LEFT;
	  },
	  get isPanMode() {
	    return this.controls.mouseButtons.PAN == THREE.MOUSE.LEFT;
	  },
	  init: function () {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	
	    this._viewToTextureScale = null;
	
	    this.addEvents('loading', 'loaded');
	
	    this.initSelection(config);
	
	    this._initTextureView(config);
	
	    this._readyDeferred = new _gear.Deferred();
	
	    this._setDoc(new _cdl.Document());
	
	    this.callParent(config);
	  },
	  ready$: function () {
	    if (this._readyDeferred == null) this._readyDeferred = new _gear.Deferred();
	    return this._readyDeferred.promise;
	  },
	  onObject3DChange: function () {
	    // console.log('object 3D change');
	    this.redraw('3D');
	  },
	  draw$: function () {
	    var _this3 = this;
	
	    return this.ready$().then(function () {
	      return _this3.object3D.ready$().then(function () {
	        return _this3.textureView.draw$().then(function () {
	          _this3.draw();
	        });
	      });
	    });
	  },
	  optimizePreview: function () {
	    this.textureView.optimizePreview();
	  },
	  optimizeZoomPreview: function () {
	    if (this.updateTextureOnZoom) {
	      this.textureView.optimizePreview();
	    }
	  },
	  _initTextureView: function () {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	
	    var textureView = this._textureView;
	    if (!textureView) {
	      textureView = this._ownedTexture = new _textureView2.TextureView({
	        canvas3D: this,
	        selection: this.selection,
	        autoDraw: false
	      });
	
	      // We need the final width to be a power of 2 so
	      // Three.js can use THREE.LinearMipMapLinearFilter
	      // Accept forced URL param
	      textureView.textureSize = _config.Config.textureSize3D ? parseInt(_config.Config.textureSize3D) : config.textureSize ? config.textureSize : 2048;
	    } else {
	      textureView.canvas3D = this;
	    }
	    this._setTextureView(textureView);
	  },
	  syncModelData3D: function () {
	
	    // console.log('syncModelData3D');
	
	    this.object3D.un(this);
	    this.object3D.dispose();
	
	    var modelData = this.modelData;
	
	    if (modelData) {
	
	      this.object3D = new _object3d.Object3D({
	        geometry: (0, _threeUtil.parseGeometry)(modelData.data),
	        textureView: this.textureView,
	        threeScene: this.threeScene
	      });
	      this.object3D.on('change', this.onObject3DChange, this);
	
	      this._viewToTextureScale = null;
	
	      // Update camera and light position
	
	      this.zoomToFront();
	    } else {
	      this.object3D = new _object3d.EmptyObject3D();
	    }
	  },
	  on_model3dchanged: function () {
	    this.syncModelData3D();
	    this.callParent.apply(this, arguments);
	  },
	  on_modeldata3dchanged: function () {
	    this.syncModelData3D();
	    this.callParent.apply(this, arguments);
	  },
	  _setTextureView: function (textureView) {
	
	    // Unlink old texture
	    var old = this.textureView;
	    if (old) {
	      this._unlinkTextureView(old);
	    }
	
	    // Link new one
	    this._textureView = textureView;
	
	    if (this.object3D) {
	      this.object3D.textureView = textureView;
	      this.redraw('3D');
	    }
	
	    textureView.on({
	      change: this.textureView_on_change.bind(this),
	      draw: this.textureView_on_draw.bind(this),
	      redraw: this.textureView_on_redraw.bind(this)
	    });
	  },
	  _unlinkTextureView: function (textureView) {
	    textureView.un(this);
	    var _ownedTexture = this._ownedTexture;
	
	    if (_ownedTexture) {
	      _ownedTexture.dispose();
	      this._ownedTexture = null;
	    }
	  },
	  textureView_on_change: function (textureView) {
	    for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      params[_key - 1] = arguments[_key];
	    }
	
	    this.fireEvent.apply(this, ['change', this].concat(_toConsumableArray(params)));
	  },
	  textureView_on_draw: function (textureView) {
	    for (var _len2 = arguments.length, params = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      params[_key2 - 1] = arguments[_key2];
	    }
	
	    this.fireEvent.apply(this, ['draw', this].concat(_toConsumableArray(params)));
	  },
	  textureView_on_redraw: function (textureView) {
	    for (var _len3 = arguments.length, params = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      params[_key3 - 1] = arguments[_key3];
	    }
	
	    this.fireEvent.apply(this, ['redraw', this].concat(_toConsumableArray(params)));
	  },
	  _setDoc: function (doc) {
	    var _this4 = this;
	
	    var old = this.doc;
	
	    if (old === doc) {
	      return (0, _gear.resolve)(); // Nothing to do
	    }
	    if (old) {
	      this.unlinkDoc(old);
	    }
	    this._document = doc;
	    this.linkDoc(doc);
	
	    var textureView = this.textureView;
	
	    // Clear the current object3D
	
	    if (this.object3D) {
	      this.object3D.un(this);
	      this.object3D.dispose();
	      this.object3D = new _object3d.EmptyObject3D();
	      this.redraw('3D');
	    }
	
	    if (_config.Config.keepLowerLeftCornerAsOrigin) {
	      this.center = this.viewCenter;
	    }
	
	    return textureView._setDoc(doc).then(function () {
	
	      if (!doc.is3D) {
	        return;
	      }
	
	      if (_this4._readyDeferred == null) _this4._readyDeferred = new _gear.Deferred();
	
	      return doc.loadModelData3D$().then(function () {
	
	        _this4.syncModelData3D();
	
	        _this4.onLoaded();
	      });
	    });
	  },
	  dispose: function () {
	    if (this.textureView) {
	      this._unlinkTextureView(this.textureView);
	    }
	    this.callParent();
	  },
	  pluginDirectDomEventHandling: function (_ref) {
	    var target = _ref.target;
	
	    return target === 'view';
	  },
	  createEventTracker: function (event, docIsland) {
	    return new _move3d.Tracker3D(event, docIsland);
	  }
	});
	
	var Canvas3D = exports.Canvas3D = StaticCanvas3D.extend(_view.InteractiveView_Mixin).extend({
	
	  typeName: 'Canvas3D',
	
	  Properties: {}
	
	});

/***/ },

/***/ 125:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.View3D = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _view = __webpack_require__(84);
	
	var _orbitControls = __webpack_require__(126);
	
	var _threeUtil = __webpack_require__(127);
	
	var _object3d = __webpack_require__(128);
	
	/* globals THREE */
	
	var _THREE = THREE;
	var Vector3 = _THREE.Vector3;
	var View3D = exports.View3D = _view.View.extend({
	
	  typeName: 'View3D',
	
	  Properties: {
	
	    autoRotate: { type: 'boolean',
	      get: function () {
	        return this.controls.autoRotate;
	      },
	      set: function (v) {
	        this.controls.autoRotate = v;
	      }
	    },
	
	    updateTextureOnZoom: { type: 'boolean', def: true },
	
	    zoomToScale: { type: 'number', def: 1.0 },
	
	    lightOffset: { type: 'number', def: 0 },
	
	    selectAndDragEnabled: { type: 'boolean', def: false }
	  },
	
	  // [TODO]
	  // backSideDarkFactor
	  // backSideColor
	
	  get is3D() {
	    return true;
	  },
	
	  isIddle: function () {
	    return !this.autoRotate && !this.cameraAnim && this.controls && this.controls.isIddle();
	  },
	  createScene: function () {
	    // textures are managed by the textureView, and tools are drawn there
	    return new _view.Composition({ textureType: '3D', main: true });
	  },
	
	
	  // [TODO] Eliminate setter for textureView, or re-link the plugins
	  //        to the new one
	
	  // Plugins that target the model and document are linked to the textureView
	  initPlugin: function (plugin) {
	    if (plugin.target === 'view') {
	      this.callParent(plugin);
	    } else {
	      this.textureView.addPlugin(plugin);
	    }
	  },
	  pluginsToDraw: function () {
	    // return filter(this._plugins,{ target: 'view' });
	    var r = [];
	    var plugins = this.plugins;
	
	    for (var k = 0, kEnd = plugins.length; k < kEnd; ++k) {
	      var plugin = plugins[k];
	      if (plugin.target === 'view') {
	        r.push(plugin);
	      }
	    }
	    return r;
	  },
	  insertViewPlugins: function (plugins) {
	    plugins.insert(0, [_view.Plugin.Renderer3D(), _view.Plugin.ViewControls3D()]);
	  },
	  initThreeScene: function () {
	
	    // Create the scene and set the scene size.
	    var threeScene = this.threeScene = new THREE.Scene();
	
	    // Create a camera, zoom it out from the model a bit, and add it to the scene.
	    var camera = this.camera = new THREE.PerspectiveCamera(45, this.width / this.height, 0.1, 4000);
	    camera.position.set(100, 100, 200);
	
	    // Allow to move the camera around the object, works exactly as OrbitControls but
	    // without dealing with user interaction
	    this.controls = new _orbitControls.OrbitConstraint(camera);
	
	    threeScene.add(camera);
	
	    // Set the background color of the scene.
	    // this._setBackgroundColor();
	
	    this.addLights();
	
	    this.updateSize();
	  },
	  addLights: function () {
	
	    // We tried different light strategies and it was really difficult to get good results using
	    // directional and spot lights. To much differences bettwen the light and dark regions.
	    // Specially for a white background. The hemisphere light that we were using so far gives
	    // the best result. But we change the way the light moves with the camera so we do not have
	    // unreal bright spots in right in front of the camera.
	
	    var threeScene = this.threeScene;
	
	
	    if (_config.Config.lights === 'Old') {
	      var light = this.light = new THREE.HemisphereLight(0xffffff, 0x808080, 1);
	      light.position.set(100, 100, 200);
	
	      threeScene.add(light);
	    } else {
	
	      if (THREE.REVISION === '73') {
	
	        //if( Config.noHemisphereLight ) {
	        //  threeScene.add( new THREE.HemisphereLight( 0x111111, 0x444444 ) );
	        //}
	
	        threeScene.add(new THREE.AmbientLight(0xa0a0a0, 0.1));
	
	        var light1 = this.light = new THREE.PointLight(0xffffff, _config.Config.lightPower ? parseFloat(_config.Config.lightPower) : 0.4);
	        // var light2 = this.light2 = new THREE.PointLight( 0xffffff, 0.1 );
	        // var light3 = this.light3 = new THREE.PointLight( 0xffffff, 0.1 );
	        light1.position.set(-1000, 0, 2000);
	        // light2.position.set( -1000, 100, -2000 );
	        // light3.position.set(  1000, -100, 2000 );
	
	        var parent = this.camera;
	        parent.add(light1);
	        // parent.add(light2);
	        // parent.add(light3);
	      } else {
	
	        var ambientLightPower = 0.3,
	            light1Power = 0.6,
	            light2Power = 0.3;
	        if (_config.Config.lightPower) {
	          var lightPowerF = _config.Config.lightPower.split(',');
	          ambientLightPower = parseFloat(lightPowerF[0]);
	          light1Power = parseFloat(lightPowerF[1]);
	          light2Power = parseFloat(lightPowerF[2]);
	        }
	
	        var lightAmbient = this.lightAmbient = new THREE.AmbientLight(0xffffff, ambientLightPower);
	        threeScene.add(lightAmbient);
	
	        var _light = this.light = new THREE.PointLight(0xffffff, light1Power);
	        var light2 = this.light2 = new THREE.PointLight(0xffffff, light2Power);
	        //const light3 = this.light3 = new THREE.PointLight( 0xffffff, 0.4 );
	        _light.position.set(-1000, 0, 1000);
	        light2.position.set(500, 1000, 1000);
	        //light3.position.set(  1000, -100, 2000 );
	
	        var _parent = this.camera;
	        _parent.add(_light);
	        _parent.add(light2);
	        //parent.add(light3);
	      }
	    }
	  },
	  zoomToFit$: function () {
	    this.zoomToFront();
	    return (0, _gear.resolve)(this);
	  },
	  objectsBBox3D: function () {
	    return this.object3D.bbox;
	  },
	  _zoomToFitCameraDistance: function () {
	
	    var bb = this.objectsBBox3D(),
	        objectSize = bb.max.y - bb.min.y;
	
	    var width = this.width;
	    var height = this.height;
	    var camera = this.camera;
	
	
	    var fov = camera.fov * (Math.PI / 180);
	
	    var distance = Math.abs(objectSize / Math.sin(fov / 2)) * 0.6 / this._zoomToScale;
	    if (width < height) {
	      distance *= Math.sqrt(height / width);
	    }
	
	    return distance;
	  },
	  _zoomToSide: function (dirX, dirY, dirZ, msTransition) {
	    var distance = this._zoomToFitCameraDistance();
	    var pos = new Vector3(dirX, dirY, dirZ).normalize().multiplyScalar(distance);
	    this._zoomToPos(pos, msTransition);
	  },
	  _zoomToPos: function (pos, msTransition) {
	    this.controls.autoRotate = false;
	    this.setCameraState({ pos: pos, target: new Vector3(0, 0, 0) }, msTransition);
	  },
	  zoomToFront: function (msTransition) {
	    this._zoomToSide(0.4, 0.2, 1, msTransition);
	  },
	  zoomToBack: function (msTransition) {
	    this._zoomToSide(0.4, 0.2, -1, msTransition);
	  },
	  zoomToRight: function (msTransition) {
	    this._zoomToSide(1, 0.2, 0.4, msTransition);
	  },
	  zoomToLeft: function (msTransition) {
	    this._zoomToSide(-1, 0.2, 0.4, msTransition);
	  },
	  rotateCameraRight: function (angle) {
	    this.rotateModelLeft(angle);
	  },
	  rotateCameraLeft: function (angle) {
	    this.rotateModelRight(angle);
	  },
	  rotateCameraDown: function (angle) {
	    this.rotateModelUp(angle);
	  },
	  rotateCameraUp: function (angle) {
	    this.rotateModelDown(angle);
	  },
	  rotateModelRight: function (angle) {
	    this.controls.rotateLeft((0, _gear.deg2rad)(angle));
	    this._updateControls();
	  },
	  rotateModelLeft: function (angle) {
	    this.rotateModelRight(-angle);
	  },
	  rotateModelDown: function (angle) {
	    this.controls.rotateUp((0, _gear.deg2rad)(angle));
	    this._updateControls();
	  },
	  rotateModelUp: function (angle) {
	    this.rotateModelDown(-angle);
	  },
	  zoomIn: function (scale) {
	    this.controls.dollyIn(scale);
	    this._updateControls();
	  },
	  zoomOut: function (scale) {
	    this.controls.dollyOut(scale);
	    this._updateControls();
	  },
	  _updateControls: function () {
	    var controls = this.controls;
	
	    controls.autoRotate = false;
	    controls.update();
	  },
	
	
	  get cameraStateString() {
	    return (0, _threeUtil.cameraToString)(this.camera, this.controls.target);
	  },
	  set cameraStateString(string) {
	    this.setCameraStateString(string, 1000);
	  },
	
	  setCameraStateString: function (string) {
	    var msTransition = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	    this.setCameraState((0, _threeUtil.cameraStateFromString)(string), msTransition);
	  },
	  setCameraState: function (state) {
	    var msTransition = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	    var camera = this.camera;
	    var controls = this.controls;
	
	    if (msTransition === 0) {
	      camera.position.copy(state.pos);
	      controls.target.copy(state.target);
	      camera.updateProjectionMatrix();
	      controls.update();
	      this.redraw('3D');
	    } else {
	      this.cameraAnim = new _threeUtil.CameraAnimation({ camera: camera, controls: controls,
	        ms: msTransition,
	        to: state
	      });
	    }
	  },
	  onOrbitControlChange: function () {
	    this.redraw('3D');
	  },
	  triggerZoomEvents: function () {
	    var zoom = this.controls.zoom;
	
	    // [TODO] This should be responsability of each plugin, avoid invalidating
	    // the tools layers if there isn't a tool
	
	    this.redraw('plugins', 'tools');
	
	    this.fireEvent('zoomupdated', this, zoom);
	    this.fireEvent('change', this);
	    var textureView = this.textureView;
	
	    textureView.fireEvent('zoomupdated', textureView, zoom);
	    textureView.fireEvent('change', textureView, zoom);
	  },
	
	  debouncedTriggerZoomEvents: (0, _lodash.debounce)(function () {
	    this.triggerZoomEvents();
	  }, 500),
	
	  onOrbitControlZoomUpdated: function () {
	    if (this.updateTextureOnZoom) {
	      this.triggerZoomEvents();
	    } else {
	      this.debouncedTriggerZoomEvents();
	    }
	  },
	
	
	  // This function is triggered once per animation frame
	  // We are auto rotating and updating the camera animation here
	
	  draw: function () {
	
	    this.object3D.drawTextures();
	
	    var cameraAnim = this.cameraAnim;
	    var controls = this.controls;
	
	
	    if (this.autoRotate || cameraAnim) {
	
	      if (cameraAnim) {
	        if (!cameraAnim.update()) {
	          this.cameraAnim = null;
	        }
	      }
	      controls.update();
	      this.redraw('3D');
	    }
	
	    if (this.object3D.animate(this.clock.getDelta())) {
	      this.redraw('3D');
	    }
	
	    this.callParent();
	  },
	
	
	  // This function is issued every time the 3D scene needs to be updated
	  // by the Renderer3D plugin
	
	  draw3D: function (renderer) {
	    var object3D = this.object3D;
	    var camera = this.camera;
	    // console.log('draw3D');
	    // Create a dummy 3D object, so we always have something to show
	    // It could also serve as a loading animation and simplify the code
	
	    this.setLightPos();
	    object3D.draw(renderer, camera);
	  },
	
	
	  get controlsEnabled() {
	    return this.controls.enabled;
	  },
	  set controlsEnabled(state) {
	    var controls = this.controls;
	    if (state === false && this._controlsPanning) {
	      controls.onMouseUp();
	      this._controlsPanning = false;
	    }
	    controls.enabled = state;
	  },
	
	  // [Review]
	  // You need to pass preserveDrawingBuffer at creation if you want to use this function
	  image: function () {
	    return this.canvas('3D').toDataURL("image/png");
	  },
	  setLightPos: function () {
	
	    var cameraPos = this.camera.position,
	        lightOffset = this.lightOffset;
	
	    if (_config.Config.lights === 'Old') {
	
	      var lightPos = this.light.position;
	      if (lightOffset === 0) {
	        lightPos.copy(cameraPos);
	      } else {
	        var bb = this.objectsBBox3D();
	
	        var bb_max = bb.max,
	            center = bb.center;
	
	        var b = new Vector3(0, lightOffset, 0);
	        var c = new Vector3().subVectors(cameraPos, center);
	        var n = new Vector3().crossVectors(b, c);
	        var l = new Vector3().addVectors(center, n);
	
	        l.y = bb_max.y;
	
	        lightPos.copy(new Vector3().addVectors(cameraPos, new Vector3().addVectors(cameraPos, l)));
	      }
	    }
	  },
	  updateSize: function (width, height) {
	    this._previousZoomToFitDistance = this._zoomToFitCameraDistance();
	    this.callParent(width, height);
	  },
	
	
	  // Called just before the resize events, after the sizing is done
	  postResize: function () {
	    var camera = this.camera;
	    var controls = this.controls;
	    var width = this.width;
	    var height = this.height;
	
	
	    this.callParent();
	
	    camera.aspect = width / height;
	    camera.updateProjectionMatrix();
	
	    // For width less than height aspect ratio, we need to move the camera manually to maintain
	    // the same position of the object in the 3D view
	    var newZoomToFitDistance = this._zoomToFitCameraDistance();
	    camera.position.multiplyScalar(newZoomToFitDistance / this._previousZoomToFitDistance);
	    camera.updateProjectionMatrix();
	
	    controls.update();
	  },
	  fireResizeEvent: function () {
	    this.textureView.fireResizeEvent();
	    this.callParent();
	  },
	  init: function () {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	
	    this.clock = new THREE.Clock();
	
	    this.object3D = new _object3d.EmptyObject3D();
	
	    this.callParent(config);
	
	    this.initThreeScene();
	  },
	  appendTo: function (domElement, id) {
	
	    this.callParent(domElement, id);
	
	    // Upgrade OrbitConstraint to OrbitControls so that we can pan around with the mouse
	    var controls = this.controls = new _orbitControls.OrbitControls(this.camera, domElement);
	    this._controlsPanning = false;
	
	    // Disable panning, orbit looks weirds after using it
	    (0, _lodash.assign)(controls, {
	      autoRotate: false,
	      autoRotateSpeed: 5.0,
	      enableKeys: false,
	      enableDamping: true,
	      dampingFactor: 0.96
	    });
	
	    controls.addEventListener('change', (0, _lodash.bind)(this.onOrbitControlChange, this));
	    controls.addEventListener('zoomupdated', (0, _lodash.bind)(this.onOrbitControlZoomUpdated, this));
	
	    return this;
	  },
	
	
	  // [TODO]
	
	  getViewPortTransform: function () {
	    return new _cdl.Matrix();
	  }
	});
	
	// We could simplify this by making OrbitControls a plugin
	
	_view.Plugin.ViewControls3D = _view.Plugin.extend({
	
	  target: 'view',
	
	  initPlugin: function () {
	    this.panning = false;
	  },
	  on_pointerdown: function (_ref) {
	    var view = _ref.view;
	    var event = _ref.event;
	
	    this.panning = true;
	    view.controls.on_pointerdown(event);
	  },
	
	
	  on_pointermove: (0, _view.fastThrottle)(function (_ref2) {
	    var view = _ref2.view;
	    var event = _ref2.event;
	
	    if (this.panning) {
	      view.controls.on_pointermove(event);
	    }
	  }, 10),
	
	  on_pointerup: function (_ref3) {
	    var view = _ref3.view;
	    var event = _ref3.event;
	
	    if (this.panning) {
	      this.panning = false;
	      view.controls.on_pointerup(event);
	    }
	  },
	  on_mousewheel: function (_ref4) {
	    var view = _ref4.view;
	    var event = _ref4.event;
	
	    this.panning = false;
	    view.controls.on_mousewheel(event);
	  }
	});

/***/ },

/***/ 126:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	exports.OrbitConstraint = OrbitConstraint;
	/* globals THREE */
	
	/**
	* @author qiao / https://github.com/qiao
	* @author mrdoob / http://mrdoob.com
	* @author alteredq / http://alteredqualia.com/
	* @author WestLangley / http://github.com/WestLangley
	* @author erich666 / http://erichaines.com
	*/
	
	// Modified for Grafika
	// Expose OrbitConstraint
	
	
	function OrbitConstraint(object) {
	
			this.object = object;
	
			// "target" sets the location of focus, where the object orbits around
			// and where it pans with respect to.
			this.target = new THREE.Vector3();
	
			// Limits to how far you can dolly in and out ( PerspectiveCamera only )
			this.minDistance = 0;
			this.maxDistance = Infinity;
	
			// Limits to how far you can zoom in and out ( OrthographicCamera only )
			this.minZoom = 0;
			this.maxZoom = Infinity;
	
			// How far you can orbit vertically, upper and lower limits.
			// Range is 0 to Math.PI radians.
			this.minPolarAngle = 0; // radians
			this.maxPolarAngle = Math.PI; // radians
	
			// How far you can orbit horizontally, upper and lower limits.
			// If set, must be a sub-interval of the interval [ - Math.PI, Math.PI ].
			this.minAzimuthAngle = -Infinity; // radians
			this.maxAzimuthAngle = Infinity; // radians
	
			// Set to true to enable damping (inertia)
			// If damping is enabled, you must call controls.update() in your animation loop
			this.enableDamping = false;
			this.dampingFactor = 0.25;
	
			////////////
			// internals
	
			var scope = this;
	
			var EPS = 0.000001;
	
			// Current position in spherical coordinate system.
			var theta;
			var phi;
	
			// Pending changes
			var phiDelta = 0;
			var thetaDelta = 0;
			var scale = 1;
			this.scale = scale;
			var panOffset = new THREE.Vector3();
			this.zoomChanged = false;
	
			Object.defineProperty(this, 'zoom', {
					get: function () {
							return this.scale;
					}
			});
	
			// API
	
			this.getPolarAngle = function () {
	
					return phi;
			};
	
			this.getAzimuthalAngle = function () {
	
					return theta;
			};
	
			this.panToCenter = function (angle) {
					// Pan to center, it looks very strange to rotate the model when the view is not centered
					var target = this.target;
					var targetLengthSq = target.lengthSq();
					if (targetLengthSq > 0) {
							if (targetLengthSq < 5) {
									target.copy(new THREE.Vector3(0, 0, 0));
							} else {
									target.copy(target.clone().multiplyScalar(9.5 / 10 * (1 - Math.abs(angle) / (2 * Math.PI))));
							}
					}
			};
	
			this.rotateLeft = function (angle) {
	
					thetaDelta -= angle;
	
					this.panToCenter(angle);
			};
	
			this.rotateUp = function (angle) {
	
					phiDelta -= angle;
	
					this.panToCenter(angle);
			};
	
			// pass in distance in world space to move left
			this.panLeft = function () {
	
					var v = new THREE.Vector3();
	
					return function panLeft(distance) {
	
							var te = this.object.matrix.elements;
	
							// get X column of matrix
							v.set(te[0], te[1], te[2]);
							v.multiplyScalar(-distance);
	
							panOffset.add(v);
					};
			}();
	
			// pass in distance in world space to move up
			this.panUp = function () {
	
					var v = new THREE.Vector3();
	
					return function panUp(distance) {
	
							var te = this.object.matrix.elements;
	
							// get Y column of matrix
							v.set(te[4], te[5], te[6]);
							v.multiplyScalar(distance);
	
							panOffset.add(v);
					};
			}();
	
			// pass in x,y of change desired in pixel space,
			// right and down are positive
			this.pan = function (deltaX, deltaY, screenWidth, screenHeight) {
	
					if (scope.object instanceof THREE.PerspectiveCamera) {
	
							// perspective
							var position = scope.object.position;
							var offset = position.clone().sub(scope.target);
							var targetDistance = offset.length();
	
							// half of the fov is center to top of screen
							targetDistance *= Math.tan(scope.object.fov / 2 * Math.PI / 180.0);
	
							// we actually don't use screenWidth, since perspective camera is fixed to screen height
							scope.panLeft(2 * deltaX * targetDistance / screenHeight);
							scope.panUp(2 * deltaY * targetDistance / screenHeight);
					} else if (scope.object instanceof THREE.OrthographicCamera) {
	
							// orthographic
							scope.panLeft(deltaX * (scope.object.right - scope.object.left) / screenWidth);
							scope.panUp(deltaY * (scope.object.top - scope.object.bottom) / screenHeight);
					} else {
	
							// camera neither orthographic or perspective
							console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
					}
			};
	
			this.dollyIn = function (dollyScale) {
	
					this.zoomChanged = true;
	
					if (scope.object instanceof THREE.PerspectiveCamera) {
	
							scale /= dollyScale;
							this.scale /= dollyScale;
					} else if (scope.object instanceof THREE.OrthographicCamera) {
	
							scope.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom * dollyScale));
							scope.object.updateProjectionMatrix();
					} else {
	
							console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
					}
			};
	
			this.dollyOut = function (dollyScale) {
	
					this.zoomChanged = true;
	
					if (scope.object instanceof THREE.PerspectiveCamera) {
	
							scale *= dollyScale;
							this.scale *= dollyScale;
					} else if (scope.object instanceof THREE.OrthographicCamera) {
	
							scope.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / dollyScale));
							scope.object.updateProjectionMatrix();
					} else {
	
							console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
					}
			};
	
			this.update = function () {
	
					var offset = new THREE.Vector3();
	
					// so camera.up is the orbit axis
					var quat = new THREE.Quaternion().setFromUnitVectors(object.up, new THREE.Vector3(0, 1, 0));
					var quatInverse = quat.clone().inverse();
	
					var lastPosition = new THREE.Vector3();
					var lastQuaternion = new THREE.Quaternion();
	
					return function () {
	
							var position = this.object.position;
	
							offset.copy(position).sub(this.target);
	
							// rotate offset to "y-axis-is-up" space
							offset.applyQuaternion(quat);
	
							// angle from z-axis around y-axis
	
							theta = Math.atan2(offset.x, offset.z);
	
							// angle from y-axis
	
							phi = Math.atan2(Math.sqrt(offset.x * offset.x + offset.z * offset.z), offset.y);
	
							theta += thetaDelta;
							phi += phiDelta;
	
							// restrict theta to be between desired limits
							theta = Math.max(this.minAzimuthAngle, Math.min(this.maxAzimuthAngle, theta));
	
							// restrict phi to be between desired limits
							phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, phi));
	
							// restrict phi to be betwee EPS and PI-EPS
							phi = Math.max(EPS, Math.min(Math.PI - EPS, phi));
	
							var radius = offset.length() * scale;
	
							// restrict radius to be between desired limits
							radius = Math.max(this.minDistance, Math.min(this.maxDistance, radius));
	
							// move target to panned location
							this.target.add(panOffset);
	
							offset.x = radius * Math.sin(phi) * Math.sin(theta);
							offset.y = radius * Math.cos(phi);
							offset.z = radius * Math.sin(phi) * Math.cos(theta);
	
							// rotate offset back to "camera-up-vector-is-up" space
							offset.applyQuaternion(quatInverse);
	
							position.copy(this.target).add(offset);
	
							this.object.lookAt(this.target);
	
							if (this.enableDamping === true) {
	
									thetaDelta *= 1 - this.dampingFactor;
									phiDelta *= 1 - this.dampingFactor;
							} else {
	
									thetaDelta = 0;
									phiDelta = 0;
							}
	
							scale = 1;
							panOffset.set(0, 0, 0);
	
							// update condition is:
							// min(camera displacement, camera rotation in radians)^2 > EPS
							// using small-angle approximation cos(x/2) = 1 - x^2 / 8
	
							if (this.zoomChanged || lastPosition.distanceToSquared(this.object.position) > EPS || 8 * (1 - lastQuaternion.dot(this.object.quaternion)) > EPS) {
	
									lastPosition.copy(this.object.position);
									lastQuaternion.copy(this.object.quaternion);
									this.zoomChanged = false;
	
									return true;
							}
	
							return false;
					};
			}();
	}
	
	// This set of controls performs orbiting, dollying (zooming), and panning. It maintains
	// the "up" direction as +Y, unlike the TrackballControls. Touch on tablet and phones is
	// supported.
	//
	//    Orbit - left mouse / touch: one finger move
	//    Zoom - middle mouse, or mousewheel / touch: two finger spread or squish
	//    Pan - right mouse, or arrow keys / touch: three finter swipe
	
	var OrbitControls = exports.OrbitControls = function (object, domElement) {
	
			var constraint = new OrbitConstraint(object);
	
			this.domElement = domElement !== undefined ? domElement : document;
	
			// API
	
			Object.defineProperty(this, 'constraint', {
	
					get: function () {
	
							return constraint;
					}
	
			});
	
			this.getPolarAngle = function () {
	
					return constraint.getPolarAngle();
			};
	
			this.getAzimuthalAngle = function () {
	
					return constraint.getAzimuthalAngle();
			};
	
			// [Grafika]
	
			this.panToCenter = function (angle) {
					return constraint.panToCenter(angle);
			};
	
			this.rotateLeft = function (angle) {
					return constraint.rotateLeft(angle);
			};
	
			this.rotateUp = function (angle) {
					return constraint.rotateUp(angle);
			};
	
			this.panLeft = function (distance) {
					return constraint.panLeft(distance);
			};
	
			this.panUp = function (distance) {
					return constraint.panUp(distance);
			};
	
			this.dollyIn = function (dollyScale) {
					return constraint.dollyIn(dollyScale);
			};
	
			this.dollyOut = function (dollyScale) {
					return constraint.dollyOut(dollyScale);
			};
	
			// Set to false to disable this control
			this.enabled = true;
	
			// center is old, deprecated; use "target" instead
			this.center = this.target;
	
			// This option actually enables dollying in and out; left as "zoom" for
			// backwards compatibility.
			// Set to false to disable zooming
			this.enableZoom = true;
			this.zoomSpeed = 1.0;
	
			// Set to false to disable rotating
			this.enableRotate = true;
			this.rotateSpeed = 1.0;
	
			// Set to false to disable panning
			this.enablePan = true;
			this.keyPanSpeed = 7.0; // pixels moved per arrow key push
	
			// Set to true to automatically rotate around the target
			// If auto-rotate is enabled, you must call controls.update() in your animation loop
			this.autoRotate = false;
			this.autoRotateSpeed = 2.0; // 30 seconds per round when fps is 60
	
			// Set to false to disable use of the keys
			this.enableKeys = true;
	
			// The four arrow keys
			this.keys = { LEFT: 37, UP: 38, RIGHT: 39, BOTTOM: 40 };
	
			// Mouse buttons
			this.mouseButtons = { ORBIT: THREE.MOUSE.LEFT, ZOOM: THREE.MOUSE.MIDDLE, PAN: THREE.MOUSE.RIGHT };
	
			////////////
			// internals
	
			var scope = this;
	
			var rotateStart = new THREE.Vector2();
			var rotateEnd = new THREE.Vector2();
			var rotateDelta = new THREE.Vector2();
	
			var panStart = new THREE.Vector2();
			var panEnd = new THREE.Vector2();
			var panDelta = new THREE.Vector2();
	
			var dollyStart = new THREE.Vector2();
			var dollyEnd = new THREE.Vector2();
			var dollyDelta = new THREE.Vector2();
	
			var STATE = {
					NONE: -1,
					ROTATE: 0,
					DOLLY: 1,
					PAN: 2,
					TOUCH_ROTATE: 3,
					TOUCH_DOLLY: 4,
					TOUCH_PAN: 5
			};
	
			var state = STATE.NONE;
	
			// for reset
	
			this.target0 = this.target.clone();
			this.position0 = this.object.position.clone();
			this.zoom0 = this.object.zoom;
	
			// events
	
			var zoomUpdatedEvent = { type: 'zoomupdated' };
			var changeEvent = { type: 'change' };
			var startEvent = { type: 'start' };
			var endEvent = { type: 'end' };
	
			// pass in x,y of change desired in pixel space,
			// right and down are positive
			function pan(deltaX, deltaY) {
	
					var element = scope.domElement === document ? scope.domElement.body : scope.domElement;
	
					constraint.pan(deltaX, deltaY, element.clientWidth, element.clientHeight);
			}
	
			this.update = function () {
	
					if (this.autoRotate && state === STATE.NONE) {
	
							constraint.rotateLeft(getAutoRotationAngle());
					}
	
					var zoomChanged = constraint.zoomChanged;
	
	
					if (constraint.update() === true) {
	
							if (zoomChanged) {
									this.dispatchEvent(zoomUpdatedEvent);
							}
							this.dispatchEvent(changeEvent);
					}
			};
	
			this.reset = function () {
	
					state = STATE.NONE;
	
					this.target.copy(this.target0);
					this.object.position.copy(this.position0);
					this.object.zoom = this.zoom0;
	
					this.object.updateProjectionMatrix();
					this.dispatchEvent(changeEvent);
					this.dispatchEvent(zoomUpdatedEvent);
	
					this.update();
			};
	
			function getAutoRotationAngle() {
	
					return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
			}
	
			function getZoomScale() {
	
					return Math.pow(0.95, scope.zoomSpeed);
			}
	
			// [grafika]
			/*
	  function onDblClick( event ) {
	    event.preventDefault();
	   scope.autoRotate = ! scope.autoRotate;
	  }
	  */
	
			function handleTouchStartDolly(event) {
	
					//console.log( 'handleTouchStartDolly' );
	
					var distance = event.pointers[1].current.minus(event.pointers[0].current).norm();
	
					dollyStart.set(0, distance);
			}
	
			function handleTouchMoveDolly(event) {
	
					//console.log( 'handleTouchMoveDolly' );
	
					var distance = event.pointers[1].current.minus(event.pointers[0].current).norm();
	
					dollyEnd.set(0, distance);
	
					dollyDelta.subVectors(dollyEnd, dollyStart);
	
					if (dollyDelta.y > 0) {
	
							constraint.dollyOut(getZoomScale());
					} else if (dollyDelta.y < 0) {
	
							constraint.dollyIn(getZoomScale());
					}
	
					dollyStart.copy(dollyEnd);
	
					scope.update();
			}
	
			this.isIddle = function () {
					return state === STATE.NONE;
			};
	
			// [grafika]
			this.on_pointerdown = function (_ref) {
					var event = _ref.event;
					var pointers = _ref.pointers;
	
	
					if (pointers.length === 2) {
	
							if (scope.enableZoom) {
									handleTouchStartDolly(event);
									state = STATE.TOUCH_DOLLY;
							}
	
							return;
					}
	
					if (scope.enabled === false) {
							return;
					}
	
					// [grafika]
					scope.autoRotate = false;
	
					// [grafika]
					// event.preventDefault();
	
					if (event.button === scope.mouseButtons.ORBIT) {
	
							if (scope.enableRotate === false) {
									return;
							}
	
							state = STATE.ROTATE;
	
							rotateStart.set(event.clientX, event.clientY);
					} else if (event.button === scope.mouseButtons.ZOOM) {
	
							if (scope.enableZoom === false) {
									return;
							}
	
							state = STATE.DOLLY;
	
							dollyStart.set(event.clientX, event.clientY);
					} else if (event.button === scope.mouseButtons.PAN) {
	
							if (scope.enablePan === false) {
									return;
							}
	
							state = STATE.PAN;
	
							panStart.set(event.clientX, event.clientY);
					}
	
					if (state !== STATE.NONE) {
	
							// [grafika]
							// document.addEventListener( 'mousemove', onMouseMove, false );
							// document.addEventListener( 'mouseup', onMouseUp, false );
							scope.dispatchEvent(startEvent);
					}
			};
	
			// [grafika]
			this.on_pointermove = function (event) {
	
					if (state === STATE.TOUCH_DOLLY && event.pointers.length !== 2) {
							state = STATE.NONE;
							return;
					}
	
					if (scope.enabled === false) {
							return;
					}
	
					// [grafika]
					// event.preventDefault();
	
					var element = scope.domElement === document ? scope.domElement.body : scope.domElement;
	
					if (state === STATE.TOUCH_DOLLY) {
	
							if (scope.enableZoom === false) {
									return;
							}
	
							event.view.optimizeZoomPreview();
	
							handleTouchMoveDolly(event);
					} else if (state === STATE.ROTATE) {
	
							if (scope.enableRotate === false) {
									return;
							}
	
							rotateEnd.set(event.clientX, event.clientY);
							rotateDelta.subVectors(rotateEnd, rotateStart);
	
							// rotating across whole screen goes 360 degrees around
							constraint.rotateLeft(2 * Math.PI * rotateDelta.x / element.clientWidth * scope.rotateSpeed);
	
							// rotating up and down along whole screen attempts to go 360, but limited to 180
							constraint.rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight * scope.rotateSpeed);
	
							rotateStart.copy(rotateEnd);
					} else if (state === STATE.DOLLY) {
	
							if (scope.enableZoom === false) {
									return;
							}
	
							event.view.optimizeZoomPreview();
	
							dollyEnd.set(event.clientX, event.clientY);
							dollyDelta.subVectors(dollyEnd, dollyStart);
	
							if (dollyDelta.y > 0) {
	
									constraint.dollyIn(getZoomScale());
							} else if (dollyDelta.y < 0) {
	
									constraint.dollyOut(getZoomScale());
							}
	
							dollyStart.copy(dollyEnd);
					} else if (state === STATE.PAN) {
	
							if (scope.enablePan === false) {
									return;
							}
	
							panEnd.set(event.clientX, event.clientY);
							panDelta.subVectors(panEnd, panStart);
	
							pan(panDelta.x, panDelta.y);
	
							panStart.copy(panEnd);
					}
	
					if (state !== STATE.NONE) {
							scope.update();
					}
			};
	
			// [grafika]
			this.on_pointerup = function () /* event */{
	
					if (scope.enabled === false) {
							return;
					}
	
					// [grafika]
					// document.removeEventListener( 'mousemove', onMouseMove, false );
					// document.removeEventListener( 'mouseup', onMouseUp, false );
					if (state !== STATE.NONE) {
							scope.dispatchEvent(endEvent);
							state = STATE.NONE;
					}
			};
	
			this.on_mousewheel = function (event) {
	
					if (scope.enabled === false || scope.enableZoom === false || state !== STATE.NONE) {
							return;
					}
	
					event.preventDefault();
					event.stopPropagation();
	
					event.view.optimizeZoomPreview();
	
					var delta = 0;
	
					if (event.wheelDelta !== undefined) {
	
							// WebKit / Opera / Explorer 9
	
							delta = event.wheelDelta;
					} else if (event.detail !== undefined) {
	
							// Firefox
	
							delta = -event.detail;
					}
	
					if (delta > 0) {
	
							constraint.dollyOut(getZoomScale());
					} else if (delta < 0) {
	
							constraint.dollyIn(getZoomScale());
					}
	
					scope.update();
					scope.dispatchEvent(startEvent);
					scope.dispatchEvent(endEvent);
			};
	
			// [grafika] Use our own input system
	
			this.dispose = function () {};
	
			// [grafika]
	
			// force an update at start
			this.update();
	};
	
	OrbitControls.prototype = Object.create(THREE.EventDispatcher.prototype);
	OrbitControls.prototype.constructor = OrbitControls;
	
	Object.defineProperties(OrbitControls.prototype, {
	
			object: {
					get: function () {
	
							return this.constraint.object;
					}
			},
	
			target: {
					get: function () {
	
							return this.constraint.target;
					},
					set: function (value) {
	
							console.warn('OrbitControls: target is now immutable. Use target.set() instead.');
							this.constraint.target.copy(value);
					}
			},
	
			zoom: {
					get: function () {
							return this.constraint.zoom;
					}
			},
	
			minDistance: {
					get: function () {
	
							return this.constraint.minDistance;
					},
					set: function (value) {
	
							this.constraint.minDistance = value;
					}
			},
	
			maxDistance: {
					get: function () {
	
							return this.constraint.maxDistance;
					},
					set: function (value) {
	
							this.constraint.maxDistance = value;
					}
			},
	
			minZoom: {
					get: function () {
	
							return this.constraint.minZoom;
					},
					set: function (value) {
	
							this.constraint.minZoom = value;
					}
			},
	
			maxZoom: {
					get: function () {
	
							return this.constraint.maxZoom;
					},
					set: function (value) {
	
							this.constraint.maxZoom = value;
					}
			},
	
			minPolarAngle: {
					get: function () {
	
							return this.constraint.minPolarAngle;
					},
					set: function (value) {
	
							this.constraint.minPolarAngle = value;
					}
			},
	
			maxPolarAngle: {
					get: function () {
	
							return this.constraint.maxPolarAngle;
					},
					set: function (value) {
	
							this.constraint.maxPolarAngle = value;
					}
			},
	
			minAzimuthAngle: {
					get: function () {
	
							return this.constraint.minAzimuthAngle;
					},
					set: function (value) {
	
							this.constraint.minAzimuthAngle = value;
					}
			},
	
			maxAzimuthAngle: {
					get: function () {
	
							return this.constraint.maxAzimuthAngle;
					},
					set: function (value) {
	
							this.constraint.maxAzimuthAngle = value;
					}
			},
	
			enableDamping: {
					get: function () {
	
							return this.constraint.enableDamping;
					},
					set: function (value) {
	
							this.constraint.enableDamping = value;
					}
			},
	
			dampingFactor: {
					get: function () {
	
							return this.constraint.dampingFactor;
					},
					set: function (value) {
	
							this.constraint.dampingFactor = value;
					}
			}
	
	});

/***/ },

/***/ 127:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CameraAnimation = undefined;
	exports.setObjectPosition = setObjectPosition;
	exports.vector3ToString = vector3ToString;
	exports.vector3FromString = vector3FromString;
	exports.rotationToString = rotationToString;
	exports.cameraToString = cameraToString;
	exports.cameraStateFromString = cameraStateFromString;
	exports.processGeometry = processGeometry;
	exports.parseGeometry = parseGeometry;
	exports.uvFromViewPoint = uvFromViewPoint;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _cdl = __webpack_require__(15);
	
	var _THREE = THREE; /* globals THREE */
	
	var Vector3 = _THREE.Vector3;
	
	
	var _parseFloat = parseFloat;
	
	function setObjectPosition(object, bbCenter) {
	  object.position.set(-bbCenter.x, -bbCenter.y, -bbCenter.z);
	  object.matrixWorldNeedsUpdate = true;
	}
	
	function n2s(n) {
	  return n.toFixed(4);
	}
	
	function vector3ToString(v) {
	  return n2s(v.x) + ' ' + n2s(v.y) + ' ' + n2s(v.z);
	}
	
	function vector3FromString(string) {
	  var s = string.split(' ');
	  return new Vector3(_parseFloat(s[0]), _parseFloat(s[1]), _parseFloat(s[2]));
	}
	
	function rotationToString(v) {
	  return n2s(v.x) + ' ' + n2s(v.y) + ' ' + n2s(v.z) + ' ' + v.order;
	}
	
	function cameraToString(camera, target) {
	  return vector3ToString(camera.position) + ',' + rotationToString(camera.rotation) + ',' + vector3ToString(target);
	}
	
	function cameraStateFromString(string) {
	  var parts = string.split(',');
	  return {
	    pos: vector3FromString(parts[0]),
	    target: vector3FromString(parts[2])
	  };
	}
	
	function properFaceNormal(face) {
	  if (face) {
	    var face_normal = face.normal;
	    if (face_normal && face_normal.lengthSq() === 0) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function properVertexNormal(face) {
	  if (face) {
	    var vertexNormal = face.vertexNormals[0];
	    if (vertexNormal && vertexNormal.lengthSq() === 0) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function processGeometry(geometry /*,divisions*/) {
	
	  var smooth = geometry; // Clone THREE.GeometryUtils.clone( geometry );
	
	  // Next, we need to merge vertices to clean up any unwanted vertex.
	  // smooth.mergeVertices();
	
	  if (!_config.Config.useBufferGeometry) {
	
	    var face0 = smooth.faces[0],
	        face1 = smooth.faces[1];
	
	    var computeFaceNormals = _config.Config.computeFaceNormals;
	    if (computeFaceNormals === 'Forced' || computeFaceNormals === 'Auto' && (!properFaceNormal(face0) || !properFaceNormal(face1))) {
	
	      console.log("Computing face normals...");
	      smooth.computeFaceNormals();
	    }
	
	    var computeVertexNormals = _config.Config.computeVertexNormals;
	    if (computeVertexNormals === 'Forced' || computeVertexNormals === 'Auto' && (!properVertexNormal(face0) || !properVertexNormal(face1))) {
	      console.log("Computing vertex normals...");
	      smooth.computeVertexNormals();
	    }
	
	    /*
	    if( divisions > 0 ) {
	        // Create a new instance of the modifier and pass the number of divisions.
	      const modifier = new THREE.SubdivisionModifier(divisions);
	        // Apply the modifier to our cloned geometry.
	      modifier.modify( smooth );
	        smooth.uvsNeedsUpdate = true;
	    }
	    */
	  }
	
	  return smooth;
	}
	
	var CameraAnimation = exports.CameraAnimation = function (config) {
	  (0, _lodash.assign)(this, config);
	  (0, _lodash.assign)(this, {
	    start: (0, _lodash.now)(),
	    from: {
	      pos: config.camera.position.clone(),
	      target: config.controls.target.clone()
	    }
	  });
	  this.finished = false;
	};
	CameraAnimation.prototype = {
	  update: function () {
	
	    if (this.finished) {
	      return false;
	    }
	    var controls = this.controls;
	    var camera = this.camera;
	    var to = this.to;
	    var from = this.from;
	    var start = this.start;
	    var ms = this.ms;
	
	
	    var t = (0, _lodash.now)(),
	        ellapsed = t - start,
	        to_pos = to.pos,
	        from_pos = from.pos,
	        to_target = to.target,
	        from_target = from.target;
	
	    if (ellapsed >= ms) {
	
	      camera.position.copy(to_pos);
	      controls.target.copy(to_target);
	      controls.update();
	      this.finished = true;
	
	      return false;
	    } else {
	
	      var current = ellapsed / ms,
	
	
	      // The next target is a direct interpolation between from and to targets
	
	      nextTarget = to.target.clone().sub(from_target).multiplyScalar(current).add(from_target),
	
	
	      // The nextPos y is a direct interpolation, x and z moves in an circle around the model
	
	      from_xz = new _cdl.Point(from_pos.x - from_target.x, from_pos.z - from_target.z),
	          to_xz = new _cdl.Point(to_pos.x - to_target.x, to_pos.z - to_target.z),
	          theta_from = from_xz.angle_rad(),
	          theta_delta = _cdl.Point.turnAngle_rad(from_xz, to_xz),
	          theta = theta_from + current * theta_delta,
	          from_radius = from_xz.norm(),
	          to_radius = to_xz.norm(),
	          radius = (to_radius - from_radius) * current + from_radius,
	          nextPos = new Vector3(radius * Math.cos(theta), 0, radius * Math.sin(theta)).add(nextTarget);
	
	      nextPos.y = (to_pos.y - from_pos.y) * current + from_pos.y;
	
	      camera.position.copy(nextPos);
	      controls.target.copy(nextTarget);
	      controls.update();
	    }
	    return true;
	  }
	};
	
	function parseGeometry(json) {
	
	  var loader = new THREE.JSONLoader();
	
	  var originalGeometry = loader.parse(json).geometry;
	
	  if (!_config.Config.useBufferGeometry && originalGeometry) {
	    if (originalGeometry instanceof THREE.BufferGeometry) {
	      originalGeometry = new THREE.Geometry().fromBufferGeometry(originalGeometry);
	    }
	  }
	
	  var smooth3D = _config.Config.smooth3D;
	  return processGeometry(originalGeometry, smooth3D ? parseInt(smooth3D) : 0);
	}
	
	function uvFromViewPoint(object, camera, viewPoint, width, height) {
	
	  camera.updateMatrixWorld();
	  camera.updateProjectionMatrix();
	
	  var vector = new Vector3(viewPoint.x / width * 2 - 1, -(viewPoint.y / height) * 2 + 1, 0.5);
	
	  vector.unproject(camera);
	
	  var raycaster = new THREE.Raycaster(camera.position, vector.sub(camera.position).normalize());
	
	  var intersects = raycaster.intersectObject(object, true);
	
	  if (intersects.length > 0) {
	
	    var uv = intersects[0].uv;
	    return uv ? new _cdl.Point(uv.x, uv.y) : null;
	  }
	  return null;
	}

/***/ },

/***/ 128:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Object3D = exports.EmptyObject3D = exports.Object3DBase = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _threeUtil = __webpack_require__(127);
	
	/* globals THREE */
	
	function setMaterialTexture(material, textureType, textureMap, texture) {
	
	  material[textureType + 'Map'] = texture;
	
	  if (texture) {
	
	    var scale = textureMap ? textureMap.scale : 1;
	    var wrap = textureMap ? textureMap.wrap : 'Stretch';
	    var repeat = textureMap && wrap !== 'Stretch' ? textureMap.repeat : 1;
	
	    material[textureType + 'Scale'] = textureType === 'normal' ? new THREE.Vector2(scale, scale) : scale;
	
	    texture.wrapS = texture.wrapT = repeat > 1 ? THREE.RepeatWrapping : THREE.ClampToEdgeWrapping;
	    texture.repeat.set(repeat, repeat);
	    texture.minFilter = repeat > 1 ? THREE.NearestMipMapLinearFilter : THREE.LinearMipMapLinearFilter;
	
	    var map = material[textureType + 'MapSlot'];
	    if (map) {
	      map.uvTransform = repeat > 1;
	      map.uvRepeat.x = repeat;
	      map.uvRepeat.y = repeat;
	    }
	  }
	}
	
	// A dummy object to avoid null checks, this could also be used later to
	// create a 3D loading animation
	
	var Object3DBase = exports.Object3DBase = _gear.Base.extend({
	  init: function () {
	    this.addEvents('change');
	  },
	  animate: function () /* delta */{}
	});
	
	var EmptyObject3D = exports.EmptyObject3D = Object3DBase.extend({
	  dispose: function () {},
	  drawTextures: function () {},
	  draw: function () /* renderer, camera */{},
	  init: function () {
	    this.bbox = {
	      min: { x: -100, y: -100, z: -100 },
	      max: { x: 100, y: 100, z: 100 }
	    };
	  },
	  uvFromViewPoint: function () /* camera, viewPoint, width, height */{
	    return null;
	  },
	  ready$: function () {
	    return (0, _gear.resolve)();
	  }
	});
	
	// Two sided object, using an opaque material for the interior
	// We use two steps rendering to be able to avoid z-order artifacts
	// The back object is first rendered as a background, then the front object
	// is rendered on top effectively making the front object always be on top
	// for all visible zones
	
	var Object3D = exports.Object3D = Object3DBase.extend({
	
	  Properties: {
	    textureView: { type: 'TextureView', owned: false, def: null, set: function (textureView) {
	        this._setTextureView(textureView);
	      }
	    },
	    geometry: { type: 'geometry', owned: false },
	
	    threeScene: { type: 'THREE.Scene', owned: false, def: null }
	  },
	
	  get backSideColor() {
	    return this.textureView.backSideColor;
	  },
	
	  getThreeTexture: function (textureType) {
	    return this.textureView.getThreeTexture(textureType);
	  },
	
	
	  // This is called for each animation frame, it will render what is needed
	  drawTextures: function () {
	    var textureView = this.textureView;
	
	    if (textureView && !textureView.autoDraw) {
	      textureView.draw();
	    }
	  },
	  init: function (config) {
	
	    this.callParent(config);
	
	    this._forcedMapReady = null;
	
	    // Inititalize materials
	    this._setTextureView(this.textureView);
	
	    this.createThreeObject();
	  },
	  uvFromViewPoint: function (camera, viewPoint, width, height) {
	    return (0, _threeUtil.uvFromViewPoint)(this.object, camera, viewPoint, width, height);
	  },
	  animate: function (delta) {
	    if (this.mixer) {
	      this.mixer.update(0.8 * delta);
	      return true;
	    }
	    return false;
	  },
	  createThreeObject: function () {
	    var geometry = this.geometry;
	    var threeScene = this.threeScene;
	    var material = this.material;
	    var materialBack = this.materialBack;
	
	    // Use BufferGeometry, an efficient and GPU friendly data structure
	    // This may not be the best for animations, we need to further explore this
	
	    var objectGeometry = _config.Config.useBufferGeometry ? new THREE.BufferGeometry().fromGeometry(geometry) : geometry;
	
	    var backSideType = this._currentBackSideType = _config.Config.backSide3D !== 'TwoSteps' ? _config.Config.backSide3D : this.textureView.model.materials[0].backSide === 'None' ? 'None' : 'TwoSteps';
	
	    switch (backSideType) {
	
	      case 'Animation':
	
	        // Make sure we are using a regular Geometry
	
	        var animGeometry = geometry instanceof THREE.BufferGeometry ? new THREE.Geometry().fromBufferGeometry(geometry) : geometry;
	
	        if (animGeometry.bones) {
	          this.object = new THREE.SkinnedMesh(animGeometry, material);
	          material.skinning = true;
	        } else {
	          this.object = new THREE.Mesh(animGeometry, material);
	        }
	
	        material.morphTargets = true;
	
	        this.mixer = new THREE.AnimationMixer(this.object);
	        var animations = geometry.animations;
	        var morphTargets = geometry.morphTargets;
	
	        if (animGeometry.bones && animations && animations.length > 0) {
	          // Add bones animation
	          var bonesClip = geometry.animations[0];
	          var bonesAction = this.mixer.clipAction(bonesClip);
	          bonesAction.play();
	        }
	        if (morphTargets && morphTargets.length > 1) {
	          var facesClip = THREE.AnimationClip.CreateFromMorphTargetSequence('morphAnimation', morphTargets, morphTargets.length - 1);
	          var facesAction = this.mixer.clipAction(facesClip);
	          facesAction.play();
	        }
	
	        break;
	
	      case 'None':
	
	        this.object = new THREE.Mesh(geometry, material);
	        break;
	
	      case 'MultiMaterial':
	
	        // This method can produce artifacts. From Three.js r69 onwards the artifacts
	        // are more notorious. Some apps may choose to use these option because of performance
	        this.object = THREE.SceneUtils.createMultiMaterialObject(objectGeometry, [material, materialBack]);
	        break;
	
	      default:
	        // 'TwoSteps'
	
	        // This is the best way we found til the moment to avoid back side artifacts
	        // We create two objects, one with each material. To render the scene we first
	        // hide the main object and then render again with the back side hidden.
	
	        this.objectBack = new THREE.Mesh(objectGeometry, materialBack);
	
	        this.object = new THREE.Mesh(objectGeometry, material);
	
	        break;
	    }
	
	    var object = this.object;
	    var objectBack = this.objectBack;
	
	
	    objectGeometry.computeBoundingBox();
	    var bb = this.bbox = objectGeometry.boundingBox.clone();
	    var bbCenter = { x: (bb.min.x + bb.max.x) / 2,
	      y: (bb.min.y + bb.max.y) / 2,
	      z: (bb.min.z + bb.max.z) / 2 };
	
	    if (objectBack) {
	      (0, _threeUtil.setObjectPosition)(objectBack, bbCenter);
	    }
	
	    (0, _threeUtil.setObjectPosition)(object, bbCenter);
	
	    bb.min.x -= bbCenter.x;bb.max.x -= bbCenter.x;
	    bb.min.y -= bbCenter.y;bb.max.y -= bbCenter.y;
	    bb.min.z -= bbCenter.z;bb.max.z -= bbCenter.z;
	
	    if (objectBack) {
	      threeScene.add(objectBack);
	    }
	    threeScene.add(object);
	  },
	  dispose: function () {
	    var threeScene = this.threeScene;
	    var object = this.object;
	    var objectBack = this.objectBack;
	
	
	    threeScene.remove(object);
	    if (objectBack) {
	      threeScene.remove(objectBack);
	    }
	  },
	  _setTextureView: function (textureView) {
	
	    this._textureView = textureView;
	
	    if (!this.object) {
	      this.createMaterialBack();
	      this.createMaterial();
	    } else {
	      this.onTextureChange();
	      this.onBackSideColorChange();
	    }
	
	    textureView.on({
	      'drawcomplete': this.invalidateTexture,
	      'synctextures': this.onTextureChange
	    }, this);
	  },
	  invalidateTexture: function () {
	    // console.log('drawcomplete');
	    this.fireEvent('change');
	  },
	  onBackSideColorChange: function () {
	    if (this.materialBack) {
	      this.materialBack.color.setHex(this.backSideColor.rgbHex);
	    }
	  },
	  onTextureChange: function () {
	    var _this = this;
	
	    // console.log('on texture change');
	    var material = this.material;
	    var materialBack = this.materialBack;
	
	
	    if (!material) {
	      return;
	    }
	
	    material.map = this.getThreeTexture('color');
	
	    var transparent = false;
	
	    if (!(_config.Config.tiledBumpMap || _config.Config.tiledNormalMap)) {
	
	      (0, _lodash.forEach)(['normal', 'bump', 'specular', 'displacement', 'alpha'], function (textureType) {
	        var textureMap = _this.textureView.getFixedTextureMap(textureType),
	            threeTexture = _this.getThreeTexture(textureType);
	
	        setMaterialTexture(material, textureType, textureMap, threeTexture);
	
	        if (textureType === 'alpha') {
	          transparent = true;
	
	          if (materialBack) {
	            setMaterialTexture(materialBack, textureType, textureMap, threeTexture);
	          }
	
	          materialBack.needsUpdate = true;
	        }
	      });
	    }
	    material.transparent = transparent;
	    if (materialBack) {
	      materialBack.transparent = transparent;
	    }
	
	    material.needsUpdate = true;
	    this.invalidateTexture();
	  },
	  createMaterial: function () {
	    var _this2 = this;
	
	    /*
	        this.material = new THREE.MeshLambertMaterial({
	          color: 0xf80505,
	          side: THREE.FrontSide
	        });
	        return;
	      */
	
	    var materialType = _config.Config.threeMaterialType ? 'Mesh' + _config.Config.threeMaterialType + 'Material' : 'MeshPhongMaterial';
	
	    if (materialType === 'MeshPhongMaterial') {
	      this.material = new THREE[materialType]({
	        side: THREE.FrontSide,
	        shading: THREE.SmoothShading,
	        reflectivity: _config.Config.reflectivity || 0,
	        specular: 0x000000,
	        shininess: _config.Config.shininess || 0
	      });
	    } else {
	      this.material = new THREE[materialType]({
	        side: THREE.FrontSide,
	        roughness: _config.Config.roughness ? parseFloat(_config.Config.roughness) : 0.76,
	        metalness: _config.Config.metalness ? parseFloat(_config.Config.metalness) : 0.0
	      });
	    }
	
	    // Testing
	    var alphaMap = _config.Config.alphaMap;
	    if (alphaMap) {
	      (function () {
	        // load a texture, set wrap mode to repeat
	        var loader = new THREE.TextureLoader();
	        loader.crossOrigin = '';
	        var texture = loader.load(alphaMap, function () {
	          _this2.invalidateTexture();
	        });
	
	        texture.wrapS = THREE.RepeatWrapping;
	        texture.wrapT = THREE.RepeatWrapping;
	        var repeatS = _config.Config.tiledBumpMapRepeat || _config.Config.tiledMapRepeat;
	        var repeat = repeatS ? parseInt(repeatS) : 16;
	        texture.repeat.set(repeat, repeat);
	
	        var setAlphaMap = function (material) {
	          material.alphaMap = texture;
	          material.transparent = true;
	          material.needsUpdate = true;
	          var map = material.alphaMapSlot;
	          if (map) {
	            map.uvTransform = true;
	            map.uvRepeat.x = repeat;
	            map.uvRepeat.y = repeat;
	          }
	        };
	
	        setAlphaMap(_this2.material);
	        if (_this2.materialBack) {
	          setAlphaMap(_this2.materialBack);
	        }
	      })();
	    }
	
	    var tiledMap = _config.Config.tiledBumpMap || _config.Config.tiledNormalMap;
	    if (tiledMap) {
	
	      this._forcedMapReady = new _gear.Deferred();
	
	      // load a texture, set wrap mode to repeat
	      var onLoad = function () {
	        _this2.invalidateTexture();
	        _this2._forcedMapReady.resolve();
	      };
	
	      var _loader = new THREE.TextureLoader();
	      _loader.crossOrigin = '';
	      var _texture = _loader.load(tiledMap, onLoad, undefined, onLoad);
	
	      _texture.wrapS = THREE.RepeatWrapping;
	      _texture.wrapT = THREE.RepeatWrapping;
	
	      var _repeatS = _config.Config.tiledBumpMapRepeat || _config.Config.tiledMapRepeat;
	      var _repeat = _repeatS ? parseInt(_repeatS) : 16;
	      _texture.repeat.set(_repeat, _repeat);
	
	      _texture.minFilter = THREE.NearestMipMapLinearFilter;
	
	      var tiledMapScale = _config.Config.tiledMapScale;
	      var material = this.material;
	
	      var map = void 0;
	      if (_config.Config.tiledBumpMap) {
	        material.bumpMap = _texture;
	        if (tiledMapScale) {
	          material.bumpScale = parseFloat(tiledMapScale);
	        }
	        map = material.bumpMapSlot;
	      } else {
	        material.normalMap = _texture;
	        if (tiledMapScale) {
	          var scale = parseFloat(tiledMapScale);
	          material.normalScale = new THREE.Vector2(scale, scale);
	        }
	        map = material.normalMapSlot;
	      }
	
	      map.uvTransform = true;
	      map.uvRepeat.x = _repeat;
	      map.uvRepeat.y = _repeat;
	    }
	
	    this.onTextureChange();
	  },
	  ready$: function () {
	    var deferred = this._forcedMapReady;
	    return deferred ? deferred.promise : (0, _gear.resolve)();
	  },
	  createMaterialBack: function () {
	
	    this.materialBack = new THREE.MeshLambertMaterial({
	      color: this.backSideColor.rgbHex,
	      side: THREE.BackSide
	    });
	  },
	  draw: function (renderer, camera) {
	    var threeScene = this.threeScene;
	    var object = this.object;
	    var objectBack = this.objectBack;
	
	
	    if (this._currentBackSideType === 'TwoSteps') {
	
	      objectBack.visible = true;
	      object.visible = false;
	
	      renderer.render(threeScene, camera);
	
	      objectBack.visible = false;
	      object.visible = true;
	
	      renderer.autoClear = false;
	    }
	
	    renderer.render(threeScene, camera);
	
	    renderer.autoClear = true;
	  }
	});

/***/ },

/***/ 129:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Preview3D = exports.thumbnailImage3D$ = undefined;
	exports.createPreview3D = createPreview3D;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _view = __webpack_require__(84);
	
	var _canvas3d = __webpack_require__(124);
	
	var canvas3D = null;
	
	function _thumbnailImage$(config) {
	
	  var size = config.size === undefined ? 256 : config.size;
	
	  if (!canvas3D) {
	    canvas3D = new _canvas3d.Canvas3D({ width: size, height: size, preserveDrawingBuffer: true, autoDraw: false });
	  } else if (canvas3D.width !== size) {
	    canvas3D.updateSize(size, size);
	  }
	
	  if (config.canvas3D) {
	    // Copy camera position from the user view
	    canvas3D.cameraStateString = config.canvas3D.cameraStateString;
	  }
	
	  return canvas3D.showDocument$(config.document).then(function () {
	    return canvas3D.draw$().then(function () {
	      return canvas3D.image();
	    });
	  });
	}
	
	var currentPromise = (0, _gear.resolve)();
	
	var thumbnailImage3D$ = exports.thumbnailImage3D$ = function (config) {
	  currentPromise = currentPromise.then(function () {
	    return _thumbnailImage$(config);
	  });
	  return currentPromise;
	};
	
	// Cx.Preview3D({ renderTo: ..., id: ... });
	
	var Preview3D = exports.Preview3D = _canvas3d.Canvas3D.extend({
	  init: function () {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	
	    this.callParent(config);
	
	    if (config.id) {
	      this.load$(config.id).then(this.commit$);
	    }
	  }
	});
	
	function createPreview3D(domId, docId, a) {
	  var config = { appendTo: (0, _view.g$)('#' + domId), id: docId };
	  if ((0, _lodash.isPlainObject)(a)) {
	    (0, _lodash.assign)(config, a);
	  } else if (a) {
	    config.documentFilter = a;
	  }
	  return Preview3D(config);
	}

/***/ }

})
});
;


/** WEBPACK FOOTER **
 ** canvas3d.js
 **/